"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.outlineBodyModule = void 0;
var angular_1 = __importDefault(require("angular"));
var outlineBody_1 = require("./services/outlineBody");
var outlineKeyboardHelp_1 = require("./services/outlineKeyboardHelp");
var editBodyAuthority_1 = require("./services/editBodyAuthority");
var outlineThreadLink_1 = require("./services/outlineThreadLink");
var threadScopeActions_1 = require("./services/threadScopeActions");
var outlineTaskPromote_1 = require("./services/outlineTaskPromote");
var outlineMapPrefs_1 = require("./services/outlineMapPrefs");
var outlineDisplayCaption_1 = require("./services/outlineDisplayCaption");
/**
 * Outline / presentation map bound to pnBody.
 *
 * Primary flow (see editBodyAuthority.ts):
 *   OPEN  — body = server pnBody; textarea shows it
 *   TYPE  — user edits in the one persistent textarea
 *   ACT   — Save / Map / crypto flush that text, then act
 *
 * Map is a derived view of the same body; structure keys may write back.
 * Toggling Map on/off never replaces the textarea element.
 *
 * View mode (default): keyboard nav / fold. Edit mode: e / F2 / double-click.
 * Structure toolbar (present / touch): + item, child, indent, outdent, collapse/expand all.
 */
exports.outlineBodyModule = angular_1.default.module('aud.outlineBody', []).directive('audOutlineBody', [
    '$timeout',
    '$window',
    '$injector',
    function ($timeout, $window, $injector) {
        return {
            restrict: 'E',
            scope: {
                body: '=',
                /** Two-way: parent row.edit.bodyRows (more/less rows). */
                rows: '=?',
                /** Note ID — scopes draft/typing apply so switching editors cannot stomp another row. */
                rowId: '=?',
                /** Host pilot_note (task/topic/flow) for Link▾ New Task gate. */
                hostRow: '=?',
                enabled: '=?',
            },
            template: "\n        <div\n          class=\"aud-outline\"\n          ng-if=\"vm.show\"\n          ng-class=\"{\n            'aud-outline--dark': vm.mapDark,\n            'aud-outline--map-on': vm.mapOn,\n            'aud-outline--present': vm.presentMode,\n            'aud-outline--splitting': vm.splitting\n          }\"\n        >\n          <div class=\"aud-outline__toolbar\">\n            <label class=\"aud-outline__toggle\">\n              <input type=\"checkbox\" ng-model=\"vm.mapOn\" ng-change=\"vm.onMapToggle()\" />\n              Map\n            </label>\n            <span class=\"aud-outline__mode\" ng-if=\"vm.mapOn\">\n              <span ng-if=\"!vm.editMode\" class=\"label label-default\">view</span>\n              <span ng-if=\"vm.editMode\" class=\"label label-primary\">edit</span>\n            </span>\n            <span class=\"aud-outline__row-display\" title=\"How this note appears on result rows\">\n              <a href class=\"task-action\" ng-click=\"vm.setRowDisplayMode('caption', $event)\"\n                 ng-class=\"{'aud-outline__active': vm.rowDisplayMode === 'caption'}\">Caption</a>\n              <a href class=\"task-action\" ng-click=\"vm.setRowDisplayMode('outline', $event)\"\n                 ng-class=\"{'aud-outline__active': vm.rowDisplayMode === 'outline'}\">Outline</a>\n              <a href class=\"task-action\" ng-click=\"vm.setRowDisplayMode('text', $event)\"\n                 ng-class=\"{'aud-outline__active': vm.rowDisplayMode === 'text'}\">Text</a>\n            </span>\n            <span class=\"aud-outline__row-caption\" ng-if=\"vm.rowDisplayMode === 'caption'\">\n              <input\n                type=\"text\"\n                class=\"form-control input-sm aud-outline__row-caption-input\"\n                ng-model=\"vm.rowCaptionDraft\"\n                ng-blur=\"vm.commitRowCaption()\"\n                ng-keydown=\"vm.onRowCaptionKey($event)\"\n                maxlength=\"500\"\n                placeholder=\"Result-row caption\"\n                title=\"Shown on result rows instead of the body (use for s1 encoded notes)\"\n              />\n            </span>\n            <span class=\"aud-outline__height\" title=\"Textarea height (rows)\">\n              <a href class=\"task-action\" ng-click=\"vm.setRows(12, $event)\" ng-class=\"{'aud-outline__active': vm.rows <= 12}\">H12</a>\n              <a href class=\"task-action\" ng-click=\"vm.setRows(20, $event)\" ng-class=\"{'aud-outline__active': vm.rows === 20}\">H20</a>\n              <a href class=\"task-action\" ng-click=\"vm.setRows(30, $event)\" ng-class=\"{'aud-outline__active': vm.rows >= 30}\">H30</a>\n              <a href class=\"task-action\" ng-hide=\"vm.rows >= 30\" ng-click=\"vm.setRows(30, $event)\">more rows &gt;&gt;</a>\n              <a href class=\"task-action\" ng-show=\"vm.rows >= 30\" ng-click=\"vm.setRows(12, $event)\">less rows &lt;&lt;</a>\n            </span>\n            <span class=\"aud-outline__map-height\" ng-if=\"vm.mapOn\" title=\"Map pane height (mobile stack + max height)\">\n              <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.nudgeMapHeight(-1, $event)\" title=\"Shorter map\">Map\u2212</button>\n              <span class=\"aud-outline__zoom-label\">{{ vm.mapHeightPx }}px</span>\n              <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.nudgeMapHeight(1, $event)\" title=\"Taller map\">Map+</button>\n              <button type=\"button\" class=\"aud-outline__zoom-btn\"\n                      ng-repeat=\"h in vm.mapHeightPresets track by h\"\n                      ng-click=\"vm.setMapHeight(h, $event)\"\n                      ng-class=\"{'aud-outline__active': vm.mapHeightPx === h}\"\n                      title=\"Map height {{ h }}px\">{{ h === 180 ? 'S' : h === 280 ? 'M' : h === 400 ? 'L' : 'XL' }}</button>\n            </span>\n            <span class=\"aud-outline__layout\" ng-if=\"vm.mapOn\">\n              <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__layout-desktop\" ng-click=\"vm.setSplit(50, $event)\" title=\"50/50 (wide layout)\">50%</button>\n              <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__layout-desktop\" ng-click=\"vm.setSplit(30, $event)\" title=\"Slim text (wide layout)\">30%</button>\n              <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__layout-desktop\" ng-click=\"vm.setSplit(18, $event)\" title=\"Minimal text (wide layout)\">18%</button>\n              <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.setPresent(true, $event)\" title=\"Map only (presentation)\">Present</button>\n              <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-if=\"vm.presentMode\" ng-click=\"vm.setPresent(false, $event)\" title=\"Show text again\">Exit present</button>\n              <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.popOutMap($event)\" title=\"Open map in new window\">Pop-out</button>\n            </span>\n            <span class=\"aud-outline__zoom\" ng-if=\"vm.mapOn\">\n              <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.zoomOut($event)\" title=\"Zoom out\">\u2212</button>\n              <span class=\"aud-outline__zoom-label\">{{ vm.zoomPct }}%</span>\n              <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.zoomIn($event)\" title=\"Zoom in\">+</button>\n              <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.zoomReset($event)\" title=\"Reset zoom\">100</button>\n            </span>\n            <label\n              class=\"aud-outline__toggle\"\n              ng-if=\"vm.mapOn\"\n              title=\"Structure tools (Up/Down/Out/In\u2026). Default: on for touch, off for mouse \u2014 toggle to override\"\n            >\n              <input type=\"checkbox\" ng-model=\"vm.structChromeOn\" ng-change=\"vm.onStructChromeToggle()\" />\n              Tools\n            </label>\n            <label class=\"aud-outline__toggle aud-outline__dark-toggle\" ng-if=\"vm.mapOn\" title=\"Map dark mode\">\n              <input type=\"checkbox\" ng-model=\"vm.mapDark\" ng-change=\"vm.persistMapPrefs()\" />\n              Dark\n            </label>\n            <button\n              type=\"button\"\n              class=\"aud-outline__zoom-btn aud-outline__help-btn\"\n              ng-if=\"vm.mapOn\"\n              ng-click=\"vm.toggleHelp($event)\"\n              ng-class=\"{'aud-outline__active': vm.helpOpen}\"\n              title=\"Keyboard shortcuts (? or i)\"\n              aria-label=\"Keyboard shortcuts\"\n            >?</button>\n            <span class=\"aud-outline__hint text-muted\" ng-if=\"vm.mapOn && !vm.editMode && !vm.presentMode && vm.structChromeOn\">\n              Tap node \u00B7 Up/Down \u00B7 Out/In \u00B7 0\u20139 depth \u00B7 + Item\n            </span>\n            <span class=\"aud-outline__hint text-muted\" ng-if=\"vm.mapOn && !vm.editMode && !vm.presentMode && !vm.structChromeOn\">\n              \u2191\u2193 \u00B7 Tab indent \u00B7 0\u20139 depth \u00B7 e edit \u00B7 ? help\n            </span>\n            <span class=\"aud-outline__hint text-muted\" ng-if=\"vm.mapOn && vm.editMode\">\n              type \u00B7 Enter commit \u00B7 ,,, \u2192 peers \u00B7 Shift+Enter newline\n            </span>\n            <span class=\"aud-outline__hint text-muted\" ng-if=\"vm.mapOn && vm.presentMode\">\n              Present \u00B7 Esc exits<span ng-if=\"vm.structChromeOn\"> \u00B7 structure bar on</span>\n            </span>\n          </div>\n          <div class=\"aud-outline__help\" ng-if=\"vm.mapOn && vm.helpOpen\" ng-click=\"$event.stopPropagation()\">\n            <div class=\"aud-outline__help-head\">\n              <strong>Map keyboard</strong>\n              <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.toggleHelp($event)\" title=\"Close\">\u00D7</button>\n            </div>\n            <table class=\"aud-outline__help-table\">\n              <tr ng-repeat=\"row in vm.mapHelp track by row.keys\">\n                <th>{{ row.keys }}</th>\n                <td>{{ row.action }}</td>\n              </tr>\n            </table>\n            <div class=\"aud-outline__help-sub\">Label edit</div>\n            <table class=\"aud-outline__help-table\">\n              <tr ng-repeat=\"row in vm.editHelp track by row.keys\">\n                <th>{{ row.keys }}</th>\n                <td>{{ row.action }}</td>\n              </tr>\n            </table>\n          </div>\n          <div class=\"aud-outline__stale\" ng-if=\"vm.mapOn && vm.staleWarning\">\n            <span class=\"aud-outline__stale-msg\">{{ vm.staleWarning }}</span>\n            <a href class=\"task-action\" ng-click=\"vm.reloadMapFromBody($event)\">reload map from text</a>\n            <a href class=\"task-action\" ng-click=\"vm.dismissStale($event)\">dismiss</a>\n          </div>\n          <div\n            class=\"aud-outline__panes\"\n            ng-class=\"{\n              'aud-outline__panes--map-off': !vm.mapOn,\n              'aud-outline__panes--present': vm.presentMode\n            }\"\n          >\n            <div\n              class=\"aud-outline__text\"\n              ng-style=\"vm.mapOn && !vm.presentMode ? { flex: '0 0 ' + vm.textPct + '%' } : null\"\n            >\n              <textarea\n                class=\"boxsizingBorder mono aud-outline__textarea\"\n                rows=\"{{ rows || vm.rows || 12 }}\"\n                ng-model=\"body\"\n                ng-change=\"vm.onBodyModelChange()\"\n                ng-click=\"vm.onBodyCaret($event)\"\n                ng-keyup=\"vm.onBodyCaret($event)\"\n                ng-mouseup=\"vm.onBodyCaret($event)\"\n                ng-select=\"vm.onBodyCaret($event)\"\n                ng-blur=\"vm.onBodyBlur()\"\n              ></textarea>\n            </div>\n            <div\n              class=\"aud-outline__splitter\"\n              ng-if=\"vm.mapOn && !vm.presentMode\"\n              title=\"Drag to resize text / map\"\n              ng-mousedown=\"vm.startSplit($event)\"\n            ></div>\n            <div\n              class=\"aud-outline__map\"\n              ng-if=\"vm.mapOn\"\n              ng-style=\"vm.mapPaneStyle()\"\n              tabindex=\"0\"\n              ng-keydown=\"vm.onKey($event)\"\n              ng-click=\"vm.onMapClick($event)\"\n            >\n              <!-- Structure tools: auto-on for touch (pointer: coarse); Tools checkbox overrides -->\n              <div\n                class=\"aud-outline__map-chrome\"\n                ng-if=\"vm.structChromeOn\"\n                ng-click=\"$event.stopPropagation()\"\n              >\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__struct-btn\" ng-click=\"vm.moveUp($event)\" title=\"Move up among siblings (takes children)\" ng-disabled=\"!vm.focusId\">Up</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__struct-btn\" ng-click=\"vm.moveDown($event)\" title=\"Move down among siblings (takes children)\" ng-disabled=\"!vm.focusId\">Down</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__struct-btn\" ng-click=\"vm.outdent($event)\" title=\"Outdent\" ng-disabled=\"!vm.focusId\">Out</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__struct-btn\" ng-click=\"vm.indent($event)\" title=\"Indent\" ng-disabled=\"!vm.focusId\">In</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__struct-btn\" ng-click=\"vm.addItem($event)\" title=\"New item\">+ Item</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__struct-btn\" ng-click=\"vm.addChild($event)\" title=\"New child\" ng-disabled=\"!vm.focusId || !vm.visible.length\">+ Child</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__struct-btn\" ng-click=\"vm.expandToLevel(0, $event)\" title=\"Collapse all (key 0)\">0</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__struct-btn\"\n                        ng-repeat=\"lv in vm.levelKeys track by lv\"\n                        ng-click=\"vm.expandToLevel(lv, $event)\"\n                        title=\"Expand to level {{ lv }} (key {{ lv }})\">{{ lv }}</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__struct-btn\" ng-click=\"vm.expandAll($event)\" title=\"Expand all\">All</button>\n              </div>\n              <div\n                class=\"aud-outline__map-scale\"\n                ng-style=\"{ transform: 'scale(' + vm.zoom + ')', width: (100 / vm.zoom) + '%' }\"\n              >\n              <div class=\"aud-outline__preamble\" ng-if=\"vm.preamble\">{{ vm.preamble }}</div>\n              <ul class=\"aud-outline__tree\">\n                <li\n                  ng-repeat=\"node in vm.visible track by node.bullet.id\"\n                  class=\"aud-outline__node\"\n                  data-outline-id=\"{{ node.bullet.id }}\"\n                  ng-class=\"[\n                    'depth-' + (node.bullet.depth > 5 ? 5 : node.bullet.depth),\n                    {\n                      'is-focused': vm.focusId === node.bullet.id,\n                      'is-editing': vm.editMode && vm.focusId === node.bullet.id,\n                      'is-collapsed': node.bullet.collapsed,\n                      'has-children': node.children.length,\n                      'is-task': !!node.bullet.checkbox,\n                      'is-task-done': node.bullet.checkbox === 'done'\n                    }\n                  ]\"\n                  ng-style=\"{ 'padding-left': (node.bullet.depth * 1.1) + 'rem' }\"\n                  ng-click=\"vm.select(node.bullet.id, $event)\"\n                  ng-dblclick=\"vm.enterEdit(node.bullet.id, $event)\"\n                >\n                  <button\n                    type=\"button\"\n                    class=\"aud-outline__twist\"\n                    ng-if=\"node.children.length\"\n                    ng-click=\"vm.toggle(node.bullet.id, $event)\"\n                    title=\"Expand/collapse\"\n                  >{{ node.bullet.collapsed ? '\u25B6' : '\u25BC' }}</button>\n                  <span class=\"aud-outline__twist aud-outline__twist--spacer\" ng-if=\"!node.children.length\"></span>\n                  <span class=\"aud-outline__cb\" ng-if=\"node.bullet.checkbox === 'open'\">\u2610</span>\n                  <span class=\"aud-outline__cb\" ng-if=\"node.bullet.checkbox === 'done'\">\u2611</span>\n                  <span\n                    class=\"aud-outline__label aud-outline__label--view\"\n                    ng-if=\"!(vm.editMode && vm.focusId === node.bullet.id)\"\n                  >{{ vm.displayLabel(node.bullet) || '(empty)' }}</span>\n                  <textarea\n                    class=\"aud-outline__label aud-outline__label--edit\"\n                    rows=\"4\"\n                    ng-if=\"vm.editMode && vm.focusId === node.bullet.id\"\n                    ng-model=\"vm.editDraft\"\n                    ng-keydown=\"vm.onEditKey($event)\"\n                    ng-blur=\"vm.commitEdit()\"\n                    ng-dblclick=\"$event.stopPropagation()\"\n                  ></textarea>\n                  <!-- Outline note links: stored as &lt;t: pnid&gt; in body label; left-click opens dropdown -->\n                  <span class=\"aud-outline__tlinks\" ng-if=\"vm.threadLinks(node.bullet).length\">\n                    <span\n                      class=\"aud-outline__tlink-wrap\"\n                      ng-repeat=\"pnid in vm.threadLinks(node.bullet) track by pnid\"\n                    >\n                      <button\n                        type=\"button\"\n                        class=\"aud-outline__tlink\"\n                        ng-class=\"{ 'is-menu-open': vm.chipMenu && vm.chipMenu.pnid === pnid && vm.chipMenu.bulletId === node.bullet.id }\"\n                        ng-click=\"vm.toggleChipMenu(node.bullet.id, pnid, $event)\"\n                        title=\"Note #{{ pnid }} \u2014 click for open options\"\n                      >t:{{ pnid }}\u25BE</button>\n                      <div\n                        class=\"aud-outline__chip-menu\"\n                        ng-if=\"vm.chipMenu && vm.chipMenu.pnid === pnid && vm.chipMenu.bulletId === node.bullet.id\"\n                        ng-click=\"$event.stopPropagation()\"\n                      >\n                        <div class=\"aud-outline__chip-menu-head\">Note #{{ pnid }}</div>\n                        <button type=\"button\" class=\"aud-outline__link-item\"\n                                ng-click=\"vm.chipMenuAction('here', $event)\">Open here</button>\n                        <button type=\"button\" class=\"aud-outline__link-item\"\n                                ng-click=\"vm.chipMenuAction('tab', $event)\">Open in new tab</button>\n                        <button type=\"button\" class=\"aud-outline__link-item\"\n                                ng-click=\"vm.chipMenuAction('present', $event)\">Present map (new tab)</button>\n                        <button type=\"button\" class=\"aud-outline__link-item\"\n                                ng-click=\"vm.chipMenuAction('copy', $event)\">Copy ID</button>\n                        <button type=\"button\" class=\"aud-outline__link-item aud-outline__link-item--danger\"\n                                ng-click=\"vm.chipMenuAction('remove', $event)\">Remove link from node</button>\n                      </div>\n                    </span>\n                  </span>\n                  <span class=\"aud-outline__link-menu\" ng-if=\"vm.focusId === node.bullet.id && !vm.editMode\">\n                    <button\n                      type=\"button\"\n                      class=\"aud-outline__zoom-btn aud-outline__link-btn\"\n                      ng-click=\"vm.toggleLinkMenu(node.bullet.id, $event)\"\n                      title=\"Link a recently viewed note as &lt;t: id&gt;\"\n                    >Link\u25BE</button>\n                    <div\n                      class=\"aud-outline__link-dropdown\"\n                      ng-if=\"vm.linkMenuId === node.bullet.id\"\n                      ng-click=\"$event.stopPropagation()\"\n                    >\n                      <div class=\"aud-outline__link-dropdown-head\">Tasks</div>\n                      <button\n                        type=\"button\"\n                        class=\"aud-outline__link-item\"\n                        ng-if=\"vm.canNewOutlineTask()\"\n                        ng-disabled=\"vm.outlineTaskBusy\"\n                        ng-click=\"vm.createOutlineTask(node.bullet.id, $event)\"\n                        title=\"Create child Task under this document, mark [ ], append &lt;t: id&gt;\"\n                      >\n                        <b>New Task</b>\n                        <span>checkbox + child + link</span>\n                      </button>\n                      <div\n                        ng-if=\"!vm.canNewOutlineTask()\"\n                        class=\"aud-outline__link-empty\"\n                        title=\"Promote body to Info Document first\"\n                      >\n                        New Task needs a non-T host (promote notes to document first).\n                      </div>\n                      <div class=\"aud-outline__link-dropdown-head\">Recent notes \u2192 &lt;t: id&gt;</div>\n                      <div ng-if=\"!vm.linkMenuRecent.length\" class=\"aud-outline__link-empty\">\n                        No recent note views. Open a few notes, then Link again.\n                      </div>\n                      <button\n                        type=\"button\"\n                        class=\"aud-outline__link-item\"\n                        ng-repeat=\"n in vm.linkMenuRecent track by n.pnid\"\n                        ng-click=\"vm.attachThreadLink(node.bullet.id, n.pnid, $event)\"\n                        title=\"Append &lt;t: {{ n.pnid }}&gt; to this node\"\n                      >\n                        <b class=\"mono\">#{{ n.pnid }}</b>\n                        <span>{{ n.caption }}</span>\n                      </button>\n                      <div class=\"aud-outline__link-dropdown-foot\" ng-if=\"vm.threadLinks(node.bullet).length\">\n                        <button\n                          type=\"button\"\n                          class=\"aud-outline__link-item aud-outline__link-item--danger\"\n                          ng-repeat=\"pnid in vm.threadLinks(node.bullet) track by pnid\"\n                          ng-click=\"vm.detachThreadLink(node.bullet.id, pnid, $event)\"\n                        >Remove t:{{ pnid }}</button>\n                      </div>\n                    </div>\n                  </span>\n                  <span class=\"aud-outline__fold-tag\" ng-if=\"node.bullet.collapsed\" title=\"Collapsed in body as (+)\">(+)</span>\n                </li>\n              </ul>\n              <div class=\"aud-outline__empty text-muted\" ng-if=\"!vm.visible.length\">\n                <p>No list items yet.</p>\n                <button type=\"button\" class=\"aud-outline__zoom-btn aud-outline__empty-start\" ng-click=\"vm.addItem($event)\">\n                  Start outline\n                </button>\n                <p class=\"aud-outline__empty-hint\">Or type <code>- topic</code> in the body text (hidden in Present).</p>\n              </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div ng-if=\"!vm.show\">\n          <textarea\n            class=\"boxsizingBorder mono\"\n            rows=\"{{ vm.rows }}\"\n            style=\"width: 100%;\"\n            ng-model=\"body\"\n          ></textarea>\n        </div>\n      ",
            link: function (scope, elem, attrs) {
                /** Body string we last wrote from the map — skip one watch cycle for that value */
                var skipWatchForBody = null;
                /**
                 * Exact pnBody the in-memory map was built from (or last successfully wrote).
                 * If live body differs, map mutations must not serialize over it.
                 */
                var syncedBodySnapshot = null;
                /**
                 * After draft restore / external apply: model must win over stale textarea DOM
                 * until the user types again (otherwise open→type heal stomps recovery).
                 */
                var preferModelUntilInput = false;
                /**
                 * Map structure write rewrites the textarea via $setViewValue → ng-change.
                 * That must not run typing capture or caret→map focus (caret is usually at EOF
                 * after a full replace, which dumps highlight to the last row).
                 */
                var writingFromMap = false;
                var ZOOM_MIN = 0.7;
                var ZOOM_MAX = 1.8;
                var ZOOM_STEP = 0.1;
                /** Touch / stylus primary UI — structure bar defaults on. */
                function prefersTouchUi() {
                    try {
                        if (window.matchMedia('(pointer: coarse)').matches)
                            return true;
                        // Some hybrid devices report fine pointer but still have touch.
                        if (window.matchMedia('(hover: none)').matches)
                            return true;
                    }
                    catch (_a) {
                        /* ignore */
                    }
                    return false;
                }
                function resolveStructChromeOn(explicit) {
                    if (explicit === true || explicit === false)
                        return explicit;
                    return prefersTouchUi();
                }
                function resolvePersonId() {
                    return (0, outlineMapPrefs_1.resolvePersonIdFromScope)(scope.$parent || scope);
                }
                function getPatchFields() {
                    try {
                        var svc_1 = $injector.get('pilotNotesSyncService');
                        if (svc_1 && typeof svc_1.patchFields === 'function') {
                            return function (rowId, fields) { return svc_1.patchFields(rowId, fields); };
                        }
                    }
                    catch (_a) {
                        /* optional */
                    }
                    return null;
                }
                var prefs = (0, outlineMapPrefs_1.loadMapPrefs)();
                var rowStyle = (0, outlineMapPrefs_1.loadRowBodyDisplayStyle)(resolvePersonId(), scope.rowId);
                if (scope.rows == null || scope.rows === undefined || scope.rows === '') {
                    scope.rows = (rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.bodyRows) != null ? rowStyle.bodyRows : 12;
                }
                var initialMapHeight = (rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.mapHeightPx) != null
                    ? rowStyle.mapHeightPx
                    : typeof prefs.mapHeightPx === 'number'
                        ? prefs.mapHeightPx
                        : outlineMapPrefs_1.MAP_HEIGHT_DEFAULT;
                var initialTextPct = typeof (rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.textPct) === 'number'
                    ? rowStyle.textPct
                    : typeof prefs.textPct === 'number'
                        ? prefs.textPct
                        : 42;
                var vm = (scope.vm = {
                    show: true,
                    mapOn: false,
                    editMode: false,
                    editDraft: '',
                    doc: null,
                    forest: [],
                    visible: [],
                    focusId: null,
                    preamble: '',
                    rows: Number(scope.rows) || 12,
                    /** Set when map would have stomped diverged pnBody */
                    staleWarning: null,
                    mapDark: prefs.dark,
                    zoom: prefs.zoom,
                    zoomPct: Math.round(prefs.zoom * 100),
                    /** % width of the text pane when map is open (map gets the rest). */
                    textPct: initialTextPct,
                    /** Map pane height (stacked mobile + max-height). */
                    mapHeightPx: (0, outlineMapPrefs_1.clampMapHeight)(initialMapHeight),
                    mapHeightPresets: outlineMapPrefs_1.MAP_HEIGHT_PRESETS,
                    presentMode: false,
                    splitting: false,
                    helpOpen: false,
                    mapHelp: outlineKeyboardHelp_1.OUTLINE_MAP_HELP,
                    editHelp: outlineKeyboardHelp_1.OUTLINE_EDIT_HELP,
                    /** Structure bar: keys 1–9 (0 is separate collapse). */
                    levelKeys: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                    /**
                     * Structure tool bar (Up/Down/Out/In…).
                     * Default: on for touch UI, off for mouse; Tools checkbox persists override.
                     */
                    structChromeOn: resolveStructChromeOn(prefs.structChrome),
                    /** Focused-node Link▾ menu (recent notes → &lt;t: id&gt;). */
                    linkMenuId: null,
                    linkMenuRecent: [],
                    /** Left-click dropdown on a t: chip (same absolute pattern as Link▾). */
                    chipMenu: null,
                    /** null = follow touch auto; boolean = user override */
                    structChromePref: prefs.structChrome,
                    outlineTaskBusy: false,
                    rowDisplayMode: (0, outlineMapPrefs_1.normalizeDisplayMode)((rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.mode)
                        ? rowStyle.mode
                        : (0, outlineDisplayCaption_1.looksLikeS1EncodedBody)(scope.body)
                            ? 'caption'
                            : 'outline'),
                    rowCaptionDraft: ((rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.caption) || '').trim(),
                    persistMapPrefs: function () {
                        (0, outlineMapPrefs_1.saveMapPrefs)({
                            dark: !!vm.mapDark,
                            zoom: vm.zoom,
                            textPct: vm.textPct,
                            structChrome: vm.structChromePref,
                            mapHeightPx: vm.mapHeightPx,
                        });
                        vm.zoomPct = Math.round(vm.zoom * 100);
                        // Per-note display style (KB / brainstorm dogfood) — local + server.
                        var personId = resolvePersonId();
                        (0, outlineMapPrefs_1.saveRowBodyDisplayStyle)(personId, scope.rowId, {
                            mode: vm.rowDisplayMode,
                            caption: String(vm.rowCaptionDraft || '').trim(),
                            mapOn: !!vm.mapOn,
                            mapHeightPx: vm.mapHeightPx,
                            bodyRows: vm.rows,
                            textPct: vm.textPct,
                        });
                        (0, outlineMapPrefs_1.scheduleDisplayStyleServerSync)(personId, scope.rowId, getPatchFields());
                    },
                    setRowDisplayMode: function (mode, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.rowDisplayMode = (0, outlineMapPrefs_1.normalizeDisplayMode)(mode);
                        vm.persistMapPrefs();
                    },
                    commitRowCaption: function () {
                        vm.rowCaptionDraft = String(vm.rowCaptionDraft || '').trim().slice(0, 500);
                        vm.rowDisplayMode = 'caption';
                        vm.persistMapPrefs();
                    },
                    onRowCaptionKey: function (ev) {
                        var _a, _b;
                        if (ev.key === 'Enter') {
                            ev.preventDefault();
                            ev.stopPropagation();
                            vm.commitRowCaption();
                            (_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
                        }
                    },
                    mapPaneStyle: function () {
                        var h = vm.mapHeightPx + 'px';
                        if (vm.presentMode) {
                            return {
                                height: Math.max(vm.mapHeightPx, 320) + 'px',
                                maxHeight: '80vh',
                                minHeight: h,
                                flex: '1 1 auto',
                                overflow: 'auto',
                                boxSizing: 'border-box',
                            };
                        }
                        // Fixed viewport so Map± / S·M·L·XL always change visible height
                        // (CSS min-height alone used to fight smaller prefs).
                        return {
                            flex: '1 1 ' + (100 - vm.textPct) + '%',
                            height: h,
                            maxHeight: h,
                            minHeight: h,
                            overflow: 'auto',
                            boxSizing: 'border-box',
                        };
                    },
                    toggleHelp: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.helpOpen = !vm.helpOpen;
                        if (vm.helpOpen) {
                            $timeout(function () { return focusMapEl(); });
                        }
                    },
                    onStructChromeToggle: function () {
                        // Checkbox already flipped structChromeOn; treat as explicit user choice.
                        vm.structChromePref = !!vm.structChromeOn;
                        vm.persistMapPrefs();
                    },
                    setRows: function (n, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        var rows = n >= 30 ? 30 : n <= 12 ? 12 : n;
                        scope.rows = rows;
                        vm.rows = rows;
                        vm.persistMapPrefs();
                    },
                    setMapHeight: function (px, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.mapHeightPx = (0, outlineMapPrefs_1.clampMapHeight)(px);
                        vm.persistMapPrefs();
                    },
                    nudgeMapHeight: function (dir, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        var step = dir < 0 ? -outlineMapPrefs_1.MAP_HEIGHT_STEP : outlineMapPrefs_1.MAP_HEIGHT_STEP;
                        vm.mapHeightPx = (0, outlineMapPrefs_1.clampMapHeight)(vm.mapHeightPx + step);
                        vm.persistMapPrefs();
                    },
                    setSplit: function (textPct, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.presentMode = false;
                        vm.textPct = Math.min(70, Math.max(12, textPct));
                        vm.persistMapPrefs();
                    },
                    setPresent: function (on, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (!vm.mapOn && on) {
                            vm.mapOn = true;
                            vm.onMapToggle();
                        }
                        vm.presentMode = !!on;
                        if (on) {
                            $timeout(function () { return focusMapEl(); });
                        }
                    },
                    startSplit: function (ev) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        var panes = elem[0].querySelector('.aud-outline__panes');
                        if (!panes)
                            return;
                        vm.splitting = true;
                        var rect = panes.getBoundingClientRect();
                        var onMove = function (e) {
                            var x = e.clientX - rect.left;
                            var pct = Math.round((x / rect.width) * 100);
                            scope.$applyAsync(function () {
                                vm.textPct = Math.min(72, Math.max(12, pct));
                            });
                        };
                        var onUp = function () {
                            vm.splitting = false;
                            scope.$applyAsync(function () { return vm.persistMapPrefs(); });
                            document.removeEventListener('mousemove', onMove);
                            document.removeEventListener('mouseup', onUp);
                        };
                        document.addEventListener('mousemove', onMove);
                        document.addEventListener('mouseup', onUp);
                    },
                    popOutMap: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        flushPendingBody();
                        if (!vm.mapOn) {
                            vm.mapOn = true;
                            vm.reparseFromBody();
                        }
                        var dark = vm.mapDark;
                        var zoom = vm.zoom;
                        var nodes = vm.visible
                            .map(function (n) {
                            var pad = '&nbsp;'.repeat(Math.max(0, n.bullet.depth) * 4);
                            var twist = n.children.length
                                ? n.bullet.collapsed
                                    ? '▶ '
                                    : '▼ '
                                : '&nbsp;&nbsp;';
                            var cb = n.bullet.checkbox === 'open'
                                ? '☐ '
                                : n.bullet.checkbox === 'done'
                                    ? '☑ '
                                    : '';
                            var lab = (n.bullet.label || '(empty)')
                                .replace(/&/g, '&amp;')
                                .replace(/</g, '&lt;')
                                .replace(/>/g, '&gt;');
                            var focus = n.bullet.id === vm.focusId ? ' focus' : '';
                            return "<div class=\"n d".concat(Math.min(5, n.bullet.depth)).concat(focus, "\">").concat(pad).concat(twist).concat(cb).concat(lab, "</div>");
                        })
                            .join('');
                        var pre = (vm.preamble || '')
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;');
                        var html = "<!doctype html><html><head><meta charset=\"utf-8\"/><title>Outline map</title>\n<style>\n  body{margin:0;font:16px/1.45 system-ui,sans-serif;background:".concat(dark ? '#0f172a' : '#f1f5f9', ";color:").concat(dark ? '#f1f5f9' : '#0f172a', ";}\n  .wrap{padding:16px;transform:scale(").concat(zoom, ");transform-origin:top left;width:").concat(100 / zoom, "%;}\n  .pre{font-weight:700;margin-bottom:12px;padding:8px;border-radius:6px;background:").concat(dark ? 'rgba(59,130,246,.2)' : 'rgba(59,130,246,.12)', ";}\n  .n{padding:4px 8px;margin:2px 0;border-radius:4px;border-left:3px solid #3b82f6;}\n  .n.d1{border-left-color:#8b5cf6}.n.d2{border-left-color:#06b6d4}.n.d3{border-left-color:#10b981}\n  .n.d4{border-left-color:#f59e0b}.n.d5{border-left-color:#f43f5e}\n  .n.focus{background:").concat(dark ? 'rgba(59,130,246,.35)' : 'rgba(59,130,246,.2)', ";outline:1px solid #3b82f6;}\n  .hint{position:fixed;bottom:8px;right:12px;opacity:.5;font-size:12px;}\n</style></head><body><div class=\"wrap\">\n  ").concat(pre ? "<div class=\"pre\">".concat(pre.replace(/\n/g, '<br/>'), "</div>") : '', "\n  ").concat(nodes || '<p>No outline items</p>', "\n</div><div class=\"hint\">Pop-out snapshot \u00B7 refresh from main window after edits</div></body></html>");
                        var w = $window.open('', 'audOutlineMapPopout', 'noopener,noreferrer,width=960,height=720');
                        if (!w) {
                            vm.staleWarning = 'Pop-out blocked — allow pop-ups for this site, or use Present mode.';
                            return;
                        }
                        w.document.open();
                        w.document.write(html);
                        w.document.close();
                    },
                    zoomIn: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.zoom = Math.min(ZOOM_MAX, Math.round((vm.zoom + ZOOM_STEP) * 100) / 100);
                        vm.persistMapPrefs();
                    },
                    zoomOut: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.zoom = Math.max(ZOOM_MIN, Math.round((vm.zoom - ZOOM_STEP) * 100) / 100);
                        vm.persistMapPrefs();
                    },
                    zoomReset: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.zoom = 1;
                        vm.persistMapPrefs();
                    },
                    onMapWheel: function (ev) {
                        if (!ev.ctrlKey && !ev.metaKey)
                            return;
                        ev.preventDefault();
                        if (ev.deltaY < 0)
                            vm.zoomIn();
                        else
                            vm.zoomOut();
                    },
                    /**
                     * After each keystroke (ng-model updated isolate `body`).
                     * Schedule debounced local draft — do not rely only on parent $watch;
                     * isolate `body=` can lag AudRoamCtrl draft checksum watch by a digest.
                     */
                    onBodyModelChange: function () {
                        // Map writes also hit ng-change via $setViewValue — do not treat as typing.
                        if (writingFromMap)
                            return;
                        // Prefer native `input` capture (bindTypingCapture); keep as fallback.
                        captureTypingFromTextarea('type');
                        if (vm.mapOn) {
                            vm.onBodyCaret();
                        }
                    },
                    onBodyBlur: function () {
                        // Flush throttled typing ticks + full emergency persist (this row only).
                        try {
                            scope.$root.$broadcast('audTypingStreamFlush', { rowId: scope.rowId });
                        }
                        catch (_a) {
                            /* ignore */
                        }
                        emergencyPersistWork('blur');
                    },
                    onMapToggle: function () {
                        // Always flush live textarea into body before layout change (never model→DOM stomp).
                        flushPendingBody();
                        if (vm.mapOn) {
                            vm.staleWarning = null;
                            vm.reparseFromBody();
                            if (!vm.focusId && vm.visible.length) {
                                vm.focusId = vm.visible[0].bullet.id;
                            }
                            $timeout(function () { return focusMapEl(); });
                        }
                        else {
                            // Turning map off: body already holds truth; drop map UI state only.
                            vm.editMode = false;
                            vm.presentMode = false;
                            vm.staleWarning = null;
                            vm.doc = null;
                            vm.forest = [];
                            vm.visible = [];
                            vm.focusId = null;
                            syncedBodySnapshot = null;
                        }
                        // Remember map on/off for this note (dogfood display style).
                        vm.persistMapPrefs();
                    },
                    dismissStale: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.staleWarning = null;
                    },
                    reloadMapFromBody: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.editMode = false;
                        pullLiveBodyIntoModel();
                        vm.reparseFromBody();
                        vm.staleWarning = null;
                        focusMapFromCaret(false);
                        $timeout(function () { return focusMapEl(); });
                    },
                    /** Keep map highlight on the bullet for the textarea caret line. */
                    onBodyCaret: function (_ev) {
                        if (!vm.mapOn)
                            return;
                        if (writingFromMap)
                            return;
                        // Defer so ng-model has applied the keystroke before reparse/focus.
                        $timeout(function () {
                            if (writingFromMap)
                                return;
                            if (vm.editMode)
                                return; // map label editor owns focus chrome
                            // Only drive selection from caret when the user is in the body textarea.
                            // Map keys rewrite body with caret at EOF; following that dumps to last row.
                            var ta = getBodyTextarea();
                            if (!ta || document.activeElement !== ta)
                                return;
                            pullLiveBodyIntoModel();
                            if (isBodyDivergedFromMap() || !vm.doc) {
                                vm.reparseFromBody();
                            }
                            focusMapFromCaret(true);
                        }, 0);
                    },
                    captureFocus: function () {
                        if (!vm.focusId || !vm.doc)
                            return null;
                        var bullets = vm.doc.lines.filter(function (l) { return l.kind === 'bullet'; });
                        var bi = bullets.findIndex(function (b) { return b.id === vm.focusId; });
                        if (bi < 0)
                            return null;
                        var b = bullets[bi];
                        var nth = 0;
                        for (var i = 0; i < bi; i++) {
                            if (bullets[i].depth === b.depth && bullets[i].label === b.label)
                                nth++;
                        }
                        var visibleIndex = Math.max(0, vm.visible.findIndex(function (n) { return n.bullet.id === vm.focusId; }));
                        return { depth: b.depth, label: b.label, nth: nth, visibleIndex: visibleIndex };
                    },
                    restoreFocus: function (fp) {
                        var _a;
                        if (!vm.doc) {
                            vm.focusId = null;
                            return;
                        }
                        var bullets = vm.doc.lines.filter(function (l) { return l.kind === 'bullet'; });
                        if (fp) {
                            var nth = 0;
                            var _loop_1 = function (b) {
                                if (b.depth === fp.depth && b.label === fp.label) {
                                    if (nth === fp.nth) {
                                        vm.focusId = b.id;
                                        if (!vm.visible.some(function (n) { return n.bullet.id === b.id; }) && vm.visible.length) {
                                            var vi = Math.min(fp.visibleIndex, vm.visible.length - 1);
                                            vm.focusId = vm.visible[vi].bullet.id;
                                        }
                                        return { value: void 0 };
                                    }
                                    nth++;
                                }
                            };
                            for (var _i = 0, bullets_1 = bullets; _i < bullets_1.length; _i++) {
                                var b = bullets_1[_i];
                                var state_1 = _loop_1(b);
                                if (typeof state_1 === "object")
                                    return state_1.value;
                            }
                            if (vm.visible.length) {
                                var vi = Math.min(fp.visibleIndex, vm.visible.length - 1);
                                vm.focusId = vm.visible[vi].bullet.id;
                                return;
                            }
                        }
                        vm.focusId = ((_a = vm.visible[0]) === null || _a === void 0 ? void 0 : _a.bullet.id) || null;
                    },
                    /** Rebuild map from current live body text (never overwrites body). */
                    reparseFromBody: function () {
                        pullLiveBodyIntoModel();
                        var text = scope.body == null ? '' : String(scope.body);
                        var fp = vm.captureFocus();
                        if (!(0, outlineBody_1.hasOutlineStructure)(text)) {
                            vm.doc = (0, outlineBody_1.parseOutlineBody)(text);
                            vm.forest = [];
                            vm.visible = [];
                            vm.preamble = vm.doc.lines
                                .filter(function (l) { return l.kind === 'text'; })
                                .map(function (l) { return l.text; })
                                .join('\n');
                            vm.focusId = null;
                            syncedBodySnapshot = text;
                            return;
                        }
                        vm.doc = (0, outlineBody_1.parseOutlineBody)(text);
                        vm.forest = (0, outlineBody_1.buildOutlineForest)(vm.doc);
                        vm.visible = (0, outlineBody_1.flattenVisible)(vm.forest);
                        vm.preamble = vm.doc.lines
                            .filter(function (l) { return l.kind === 'text'; })
                            .map(function (l) { return l.text; })
                            .join('\n');
                        vm.restoreFocus(fp);
                        // Snapshot is the source text, not a re-serialize (round-trip may differ).
                        syncedBodySnapshot = text;
                    },
                    /**
                     * Map structure edit → write into body only if body still matches map snapshot.
                     * Never stomp a diverged pnBody.
                     */
                    commit: function () {
                        if (!vm.doc)
                            return false;
                        if (!guardMapWrite('Map change was not written over your pnBody text.')) {
                            return false;
                        }
                        var text = (0, outlineBody_1.serializeOutlineBody)(vm.doc);
                        writeBody(text);
                        syncedBodySnapshot = text;
                        vm.forest = (0, outlineBody_1.buildOutlineForest)(vm.doc);
                        vm.visible = (0, outlineBody_1.flattenVisible)(vm.forest);
                        vm.staleWarning = null;
                        return true;
                    },
                    select: function (id, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.editMode && vm.focusId !== id) {
                            vm.commitEdit();
                        }
                        // Selection only — refresh if body diverged so focus targets a live node.
                        if (isBodyDivergedFromMap()) {
                            guardMapWrite('pnBody changed — map reloaded from text.');
                        }
                        vm.focusId = id;
                        if (vm.linkMenuId && vm.linkMenuId !== id) {
                            vm.linkMenuId = null;
                        }
                        if (vm.chipMenu && vm.chipMenu.bulletId !== id) {
                            vm.chipMenu = null;
                        }
                        if (!vm.editMode) {
                            $timeout(function () { return focusMapEl(); });
                        }
                    },
                    displayLabel: function (bullet) {
                        if (!bullet)
                            return '';
                        return (0, outlineThreadLink_1.parseOutlineThreadLinks)(bullet.label).cleanLabel;
                    },
                    threadLinks: function (bullet) {
                        if (!bullet)
                            return [];
                        return (0, outlineThreadLink_1.parseOutlineThreadLinks)(bullet.label).pnids;
                    },
                    /** Walk up isolate parents for AudRoamCtrl helpers / history. */
                    _hostScope: function () {
                        var s = scope.$parent;
                        while (s) {
                            if (typeof s.personSearch === 'function' || (s.history && s.history.views)) {
                                return s;
                            }
                            s = s.$parent;
                        }
                        return scope.$parent;
                    },
                    openThreadLink: function (pnid, ev, forceNewTab) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.chipMenu = null;
                        var id = String(pnid || '').trim();
                        if (!id)
                            return;
                        if (forceNewTab) {
                            try {
                                $window.open((0, outlineThreadLink_1.outlineThreadLinkViewUrl)(id), '_blank');
                            }
                            catch (_a) {
                                /* ignore */
                            }
                            return;
                        }
                        var host = vm._hostScope();
                        if (host && typeof host.personSearch === 'function') {
                            host.personSearch({ pnid: id });
                            return;
                        }
                        try {
                            $window.location.href = (0, outlineThreadLink_1.outlineThreadLinkViewUrl)(id);
                        }
                        catch (_b) {
                            /* ignore */
                        }
                    },
                    /**
                     * Left-click chip → dropdown under the chip (CSS absolute, same as Link▾).
                     * No fixed/client coordinates — those broke under map zoom/overflow.
                     */
                    toggleChipMenu: function (bulletId, pnid, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        var id = String(pnid || '').trim();
                        if (!bulletId || !id)
                            return;
                        if (vm.chipMenu &&
                            vm.chipMenu.bulletId === bulletId &&
                            vm.chipMenu.pnid === id) {
                            vm.chipMenu = null;
                            return;
                        }
                        vm.focusId = bulletId;
                        vm.linkMenuId = null;
                        vm.chipMenu = { bulletId: bulletId, pnid: id };
                        $timeout(function () {
                            var closer = function (e) {
                                var t = e.target;
                                if (t && t.closest && t.closest('.aud-outline__chip-menu'))
                                    return;
                                if (t && t.closest && t.closest('.aud-outline__tlink.is-menu-open'))
                                    return;
                                vm.chipMenu = null;
                                try {
                                    document.removeEventListener('mousedown', closer, true);
                                    document.removeEventListener('keydown', onKey, true);
                                }
                                catch (_a) {
                                    /* ignore */
                                }
                                if (!scope.$root.$$phase)
                                    scope.$applyAsync();
                            };
                            var onKey = function (e) {
                                if (e.key === 'Escape')
                                    closer(e);
                            };
                            document.addEventListener('mousedown', closer, true);
                            document.addEventListener('keydown', onKey, true);
                        }, 0);
                    },
                    chipMenuAction: function (action, ev) {
                        var _a;
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        var menu = vm.chipMenu;
                        if (!menu)
                            return;
                        var bulletId = menu.bulletId, pnid = menu.pnid;
                        vm.chipMenu = null;
                        if (action === 'here') {
                            vm.openThreadLink(pnid, undefined, false);
                            return;
                        }
                        if (action === 'tab') {
                            vm.openThreadLink(pnid, undefined, true);
                            return;
                        }
                        if (action === 'present') {
                            try {
                                $window.open("/view/pnid/".concat(pnid, "?present=1"), '_blank');
                            }
                            catch (_b) {
                                /* ignore */
                            }
                            return;
                        }
                        if (action === 'copy') {
                            try {
                                if ($window.navigator && ((_a = $window.navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText)) {
                                    $window.navigator.clipboard.writeText(String(pnid));
                                }
                                else {
                                    // fallback
                                    var ta = document.createElement('textarea');
                                    ta.value = String(pnid);
                                    document.body.appendChild(ta);
                                    ta.select();
                                    document.execCommand('copy');
                                    document.body.removeChild(ta);
                                }
                            }
                            catch (_c) {
                                /* ignore */
                            }
                            return;
                        }
                        if (action === 'remove') {
                            vm.detachThreadLink(bulletId, pnid);
                        }
                    },
                    toggleLinkMenu: function (bulletId, ev) {
                        var _a;
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.chipMenu = null;
                        if (vm.linkMenuId === bulletId) {
                            vm.linkMenuId = null;
                            return;
                        }
                        vm.focusId = bulletId;
                        var host = vm._hostScope();
                        var views = (host && host.history && host.history.views) ||
                            (host && typeof ((_a = host.historyService) === null || _a === void 0 ? void 0 : _a.getViewHistory) === 'function'
                                ? host.historyService.getViewHistory()
                                : []) ||
                            [];
                        vm.linkMenuRecent = (0, threadScopeActions_1.recentNotesForThreadAdd)(views, [], 12);
                        vm.linkMenuId = bulletId;
                    },
                    _pilotNotesSync: function () {
                        try {
                            if ($injector.has('pilotNotesSyncService')) {
                                return $injector.get('pilotNotesSyncService');
                            }
                        }
                        catch (_a) {
                            /* ignore */
                        }
                        return null;
                    },
                    _resolveHostRow: function () {
                        var hr = scope.hostRow;
                        if (hr && hr.ID != null)
                            return hr;
                        // Walk parents for open edit row matching rowId
                        var s = scope.$parent;
                        var want = scope.rowId;
                        while (s) {
                            if (s.row && s.row.ID != null && (want == null || String(s.row.ID) === String(want))) {
                                return s.row;
                            }
                            s = s.$parent;
                        }
                        return {
                            ID: scope.rowId,
                        };
                    },
                    canNewOutlineTask: function () {
                        return (0, outlineTaskPromote_1.hostAllowsOutlineNewTask)(vm._resolveHostRow());
                    },
                    createOutlineTask: function (bulletId, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.outlineTaskBusy)
                            return;
                        var hostRow = vm._resolveHostRow();
                        if (!(0, outlineTaskPromote_1.hostAllowsOutlineNewTask)(hostRow)) {
                            vm.staleWarning =
                                'New Task needs a non-T host — use Add info / document first.';
                            return;
                        }
                        if (!vm.doc || !bulletId)
                            return;
                        if (isBodyDivergedFromMap()) {
                            guardMapWrite('pnBody differs from map — reloaded. Try New Task again.');
                            return;
                        }
                        var node = vm.visible.find(function (n) { return n.bullet.id === bulletId; });
                        if (!node)
                            return;
                        var existing = (0, outlineThreadLink_1.parseOutlineThreadLinks)(node.bullet.label).pnids;
                        if (existing.length) {
                            vm.staleWarning = "Already linked (t:".concat(existing[0], "). Open the chip or remove the link first.");
                            return;
                        }
                        var label = (0, outlineTaskPromote_1.cleanOutlineTaskLabel)(node.bullet.label);
                        if (!label) {
                            vm.staleWarning = 'Outline label is empty — type a task name first.';
                            return;
                        }
                        var sync = vm._pilotNotesSync();
                        if (!sync) {
                            vm.staleWarning = 'API service unavailable for New Task.';
                            return;
                        }
                        var docId = Number(hostRow.ID);
                        vm.outlineTaskBusy = true;
                        vm.staleWarning = null;
                        sync
                            .outlineNewTask(docId, { label: label })
                            .then(function (data) {
                            var taskId = data.taskId || data.task_id || data.ID;
                            if (!taskId) {
                                throw new Error('No task id returned');
                            }
                            if (!vm.doc || isBodyDivergedFromMap()) {
                                guardMapWrite('Map diverged after create — task #' + taskId + ' exists; re-link manually.');
                                return;
                            }
                            var next = (0, outlineTaskPromote_1.materializeOutlineTaskOnBullet)(vm.doc, bulletId, taskId);
                            if (!next) {
                                vm.staleWarning = "Task #".concat(taskId, " created but bullet missing \u2014 reload map.");
                                return;
                            }
                            vm.doc = next;
                            if (!vm.commit()) {
                                vm.staleWarning = "Task #".concat(taskId, " created; body link not written \u2014 save body and add <t: ").concat(taskId, ">.");
                                return;
                            }
                            vm.linkMenuId = null;
                            var host = vm._hostScope();
                            if (host && typeof host.toast === 'function') {
                                host.toast("Task #".concat(taskId, " created and linked."), 'success', 4000);
                            }
                        })
                            .catch(function (err) {
                            var msg = (err && err.message) || String(err || 'New Task failed');
                            vm.staleWarning = msg;
                            var host = vm._hostScope();
                            if (host && typeof host.toast === 'function') {
                                host.toast(msg, 'danger', 5000);
                            }
                        })
                            .finally(function () {
                            vm.outlineTaskBusy = false;
                            if (!scope.$root.$$phase) {
                                scope.$applyAsync();
                            }
                        });
                    },
                    /** Soft-stuff linked child captions when outline label still matches child body. */
                    _stuffLinkedCaptionsAfterLabelEdit: function (prevLabel, nextLabel) {
                        var prevClean = (0, outlineTaskPromote_1.cleanOutlineTaskLabel)(prevLabel);
                        var nextClean = (0, outlineTaskPromote_1.cleanOutlineTaskLabel)(nextLabel);
                        if (!prevClean || prevClean === nextClean)
                            return;
                        var pnids = (0, outlineThreadLink_1.parseOutlineThreadLinks)(nextLabel).pnids;
                        if (!pnids.length)
                            return;
                        // Gate uses expected=prevClean; server compares child body to expected.
                        // shouldStuffCaption(prev, next, child) — we do not have child yet; server enforces.
                        if (!(0, outlineTaskPromote_1.shouldStuffCaption)(prevClean, nextClean, prevClean))
                            return;
                        var sync = vm._pilotNotesSync();
                        if (!sync)
                            return;
                        var taskId = Number(pnids[0]);
                        if (!taskId)
                            return;
                        sync
                            .stuffTaskCaption(taskId, {
                            expectedBody: prevClean,
                            newBody: nextClean,
                        })
                            .then(function (data) {
                            if (data && data.stuffed) {
                                var host = vm._hostScope();
                                if (host && typeof host.toast === 'function') {
                                    host.toast("Updated task #".concat(taskId, " caption from outline."), 'info', 2500);
                                }
                            }
                        })
                            .catch(function () {
                            /* soft fail */
                        });
                    },
                    attachThreadLink: function (bulletId, pnid, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (!vm.doc || !bulletId || !pnid)
                            return;
                        if (isBodyDivergedFromMap()) {
                            guardMapWrite('pnBody differs from map — reloaded. Try Link again.');
                            return;
                        }
                        var bullet = vm.doc.lines.find(function (l) { return l.kind === 'bullet' && l.id === bulletId; });
                        if (!bullet)
                            return;
                        try {
                            var next = (0, outlineThreadLink_1.appendOutlineThreadLink)(bullet.label, pnid);
                            vm.doc = (0, outlineBody_1.updateLabel)(vm.doc, bulletId, next);
                            if (!vm.commit())
                                return;
                            vm.linkMenuId = null;
                            vm.focusId = bulletId;
                        }
                        catch (_a) {
                            /* invalid pnid */
                        }
                    },
                    detachThreadLink: function (bulletId, pnid, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (!vm.doc || !bulletId || !pnid)
                            return;
                        if (isBodyDivergedFromMap()) {
                            guardMapWrite('pnBody differs from map — reloaded. Try remove again.');
                            return;
                        }
                        var bullet = vm.doc.lines.find(function (l) { return l.kind === 'bullet' && l.id === bulletId; });
                        if (!bullet)
                            return;
                        var next = (0, outlineThreadLink_1.removeOutlineThreadLink)(bullet.label, pnid);
                        vm.doc = (0, outlineBody_1.updateLabel)(vm.doc, bulletId, next);
                        if (!vm.commit())
                            return;
                        vm.focusId = bulletId;
                    },
                    toggle: function (id, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (!vm.doc)
                            return;
                        if (vm.editMode) {
                            if (!vm.commitEdit())
                                return;
                        }
                        if (!guardMapWrite('Fold was not applied — map reloaded from pnBody.')) {
                            return;
                        }
                        // id may still be valid after guard if not stale
                        if (!vm.doc.lines.some(function (l) { return l.kind === 'bullet' && l.id === id; })) {
                            return;
                        }
                        var wasCollapsed = vm.doc.lines.find(function (l) { return l.kind === 'bullet' && l.id === id; }).collapsed;
                        vm.doc = (0, outlineBody_1.toggleCollapse)(vm.doc, id);
                        vm.commit();
                        vm.focusId = id;
                        if (wasCollapsed) {
                            focusFirstRevealedChild(id);
                        }
                        $timeout(function () {
                            focusMapEl();
                            if (vm.focusId)
                                scrollMapNodeIntoView(vm.focusId);
                        }, 0);
                    },
                    /**
                     * New sibling (or first bullet when empty). Works in Present without body text.
                     * Same as map Enter with no focus / empty outline.
                     */
                    addItem: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.editMode && !vm.commitEdit())
                            return;
                        if (!guardMapWrite())
                            return;
                        if (!vm.doc || !(0, outlineBody_1.hasOutlineStructure)(getLiveBodyText()) || !vm.visible.length) {
                            var base = getLiveBodyText();
                            var next = base + (base && !base.endsWith('\n') ? '\n' : '') + '- ';
                            writeBody(next);
                            syncedBodySnapshot = next;
                            vm.reparseFromBody();
                            var last = vm.visible[vm.visible.length - 1];
                            if (last)
                                vm.enterEdit(last.bullet.id);
                            return;
                        }
                        var anchorId = vm.focusId;
                        if (!anchorId || !vm.visible.some(function (n) { return n.bullet.id === anchorId; })) {
                            anchorId = vm.visible[vm.visible.length - 1].bullet.id;
                        }
                        var r = (0, outlineBody_1.addSiblingAfter)(vm.doc, anchorId);
                        vm.doc = r.doc;
                        if (!vm.commit())
                            return;
                        vm.focusId = r.newId;
                        vm.enterEdit(r.newId);
                    },
                    /** New child under focused node (Ctrl+Enter). */
                    addChild: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.editMode && !vm.commitEdit())
                            return;
                        if (!vm.doc || !vm.focusId || !vm.visible.length) {
                            // No parent yet — bootstrap a root item instead.
                            vm.addItem();
                            return;
                        }
                        if (!guardMapWrite())
                            return;
                        if (!vm.doc.lines.some(function (l) { return l.kind === 'bullet' && l.id === vm.focusId; })) {
                            return;
                        }
                        var r = (0, outlineBody_1.addChildUnder)(vm.doc, vm.focusId);
                        vm.doc = r.doc;
                        if (!vm.commit())
                            return;
                        vm.focusId = r.newId;
                        vm.enterEdit(r.newId);
                    },
                    indent: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.editMode && !vm.commitEdit())
                            return;
                        if (!vm.doc || !vm.focusId)
                            return;
                        if (!guardMapWrite())
                            return;
                        var id = vm.focusId;
                        vm.doc = (0, outlineBody_1.indentBullet)(vm.doc, id);
                        if (!vm.commit())
                            return;
                        vm.focusId = id;
                        $timeout(function () {
                            focusMapEl();
                            scrollMapNodeIntoView(id);
                        }, 0);
                    },
                    outdent: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.editMode && !vm.commitEdit())
                            return;
                        if (!vm.doc || !vm.focusId)
                            return;
                        if (!guardMapWrite())
                            return;
                        var id = vm.focusId;
                        vm.doc = (0, outlineBody_1.outdentBullet)(vm.doc, id);
                        if (!vm.commit())
                            return;
                        vm.focusId = id;
                        $timeout(function () {
                            focusMapEl();
                            scrollMapNodeIntoView(id);
                        }, 0);
                    },
                    /**
                     * Reorder focused node among siblings. Moves the full block
                     * (node + all nested descendants) — same as Alt+↑ / Alt+↓.
                     */
                    moveUp: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.editMode && !vm.commitEdit())
                            return;
                        if (!vm.doc || !vm.focusId)
                            return;
                        if (!guardMapWrite())
                            return;
                        var id = vm.focusId;
                        vm.doc = (0, outlineBody_1.moveBulletUp)(vm.doc, id);
                        if (!vm.commit())
                            return;
                        vm.focusId = id;
                        $timeout(function () {
                            focusMapEl();
                            scrollMapNodeIntoView(id);
                        }, 0);
                    },
                    moveDown: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.editMode && !vm.commitEdit())
                            return;
                        if (!vm.doc || !vm.focusId)
                            return;
                        if (!guardMapWrite())
                            return;
                        var id = vm.focusId;
                        vm.doc = (0, outlineBody_1.moveBulletDown)(vm.doc, id);
                        if (!vm.commit())
                            return;
                        vm.focusId = id;
                        $timeout(function () {
                            focusMapEl();
                            scrollMapNodeIntoView(id);
                        }, 0);
                    },
                    /**
                     * Apply a pure fold/structure transform to the map doc and re-commit body.
                     * Lifts focus if the focused node is hidden under a new fold.
                     */
                    applyFoldTransform: function (transform, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.editMode && !vm.commitEdit())
                            return;
                        if (!vm.doc || !(0, outlineBody_1.hasOutlineStructure)(getLiveBodyText()))
                            return;
                        if (!guardMapWrite())
                            return;
                        var keep = vm.focusId;
                        vm.doc = transform(vm.doc);
                        if (!vm.commit())
                            return;
                        // Focus may be hidden under a collapsed ancestor — lift to a visible node.
                        if (keep) {
                            var still = vm.visible.some(function (n) { return n.bullet.id === keep; });
                            if (!still && vm.visible.length) {
                                var bullets = vm.doc.lines.filter(function (l) { return l.kind === 'bullet'; });
                                var hidden = bullets.find(function (b) { return b.id === keep; });
                                if (hidden) {
                                    var pick_1 = null;
                                    var hi = bullets.findIndex(function (b) { return b.id === keep; });
                                    for (var i = hi - 1; i >= 0; i--) {
                                        if (bullets[i].depth < hidden.depth) {
                                            pick_1 = bullets[i].id;
                                            if (vm.visible.some(function (n) { return n.bullet.id === pick_1; }))
                                                break;
                                        }
                                    }
                                    vm.focusId =
                                        pick_1 && vm.visible.some(function (n) { return n.bullet.id === pick_1; })
                                            ? pick_1
                                            : vm.visible[0].bullet.id;
                                }
                                else {
                                    vm.focusId = vm.visible[0].bullet.id;
                                }
                            }
                            else {
                                vm.focusId = keep;
                            }
                        }
                        $timeout(function () {
                            focusMapEl();
                            if (vm.focusId)
                                scrollMapNodeIntoView(vm.focusId);
                        }, 0);
                    },
                    /** Fold every parent — same overview as presentation level 2. */
                    collapseAll: function (ev) {
                        vm.applyFoldTransform(function (doc) { return (0, outlineBody_1.setAllCollapsed)(doc, true); }, ev);
                    },
                    expandAll: function (ev) {
                        vm.applyFoldTransform(function (doc) { return (0, outlineBody_1.setAllCollapsed)(doc, false); }, ev);
                    },
                    /**
                     * Presentation depth cut (no virtual root):
                     * 0 = collapse all; 1–2 = top bullets only; 3–9 open nested tiers.
                     */
                    expandToLevel: function (level, ev) {
                        var n = Math.floor(Number(level));
                        var lv = Number.isFinite(n) ? Math.min(9, Math.max(0, n)) : 0;
                        vm.applyFoldTransform(function (doc) { return (0, outlineBody_1.setExpandToPresentationLevel)(doc, lv); }, ev);
                    },
                    /** Slice focused label on ,,, into peer bullets (same depth). */
                    splitFocusedIntoPeers: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (!vm.doc || !vm.focusId)
                            return;
                        if (!guardMapWrite())
                            return;
                        var r = (0, outlineBody_1.splitBulletLabelIntoPeers)(vm.doc, vm.focusId);
                        if (r.count < 2)
                            return;
                        vm.doc = r.doc;
                        vm.commit();
                        vm.focusId = r.focusId;
                        $timeout(function () {
                            focusMapEl();
                            if (vm.focusId)
                                scrollMapNodeIntoView(vm.focusId);
                        }, 0);
                    },
                    onMapClick: function (ev) {
                        var t = ev.target;
                        if (t.closest('.aud-outline__node'))
                            return;
                        if (vm.editMode)
                            vm.commitEdit();
                        focusMapEl();
                    },
                    enterEdit: function (id, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        // Already editing this node: keep caret/selection (double-click word select).
                        var wantId = id || vm.focusId;
                        if (vm.editMode && wantId && vm.focusId === wantId) {
                            return;
                        }
                        // Switching nodes: commit current label first (guarded).
                        if (vm.editMode && vm.focusId && wantId && vm.focusId !== wantId) {
                            if (!vm.commitEdit())
                                return;
                        }
                        // Do not start label edit on a stale map leaf.
                        if (isBodyDivergedFromMap()) {
                            var fp = wantId ? captureFocusById(wantId) : null;
                            guardMapWrite('pnBody differs from the map — reloaded from text. Label edit blocked until the map matches.');
                            // After reload, try to re-find by fingerprint (depth+label).
                            if (fp) {
                                var found = findBulletIdByFingerprint(fp);
                                if (found) {
                                    // Still require a second e/double-click on the fresh leaf (safer).
                                    vm.focusId = found;
                                }
                            }
                            return;
                        }
                        if (!vm.doc)
                            return;
                        var targetId = wantId;
                        if (!targetId)
                            return;
                        var node = vm.visible.find(function (n) { return n.bullet.id === targetId; });
                        if (!node)
                            return;
                        vm.focusId = targetId;
                        // Like checkbox (structured on bullet): strip `<t: id>` for the editor —
                        // chips keep the links; re-attach on commit so typing does not clobber them.
                        vm.editDraft = (0, outlineThreadLink_1.parseOutlineThreadLinks)(node.bullet.label).cleanLabel;
                        vm.editMode = true;
                        vm.staleWarning = null;
                        $timeout(function () {
                            var input = elem[0].querySelector('textarea.aud-outline__label--edit');
                            if (input) {
                                input.focus();
                                input.select();
                            }
                        });
                    },
                    commitEdit: function () {
                        if (!vm.editMode || !vm.doc || !vm.focusId) {
                            vm.editMode = false;
                            return true;
                        }
                        if (isBodyDivergedFromMap()) {
                            vm.editMode = false;
                            guardMapWrite('pnBody changed during map label edit — label was not written over your text. Map reloaded.');
                            return false;
                        }
                        var focusId = vm.focusId;
                        var prevBullet = vm.doc.lines.find(function (l) { return l.kind === 'bullet' && l.id === focusId; });
                        var prevLabel = prevBullet ? prevBullet.label : '';
                        // Multi-line box for readability; store as a single outline label line.
                        // Leading [ ] / [x] / [X] update checkbox state (same as body parse).
                        // `<t: id>` tags stay out of the editor (chips); re-merge on commit.
                        var parsed = (0, outlineBody_1.parseOutlineEditDraft)(vm.editDraft);
                        var label = (0, outlineThreadLink_1.mergeOutlineLabelEdit)(prevLabel, parsed.label);
                        vm.doc = (0, outlineBody_1.updateBulletFromEdit)(vm.doc, focusId, label, parsed.checkbox);
                        // Auto-slice "a,,,b,,,c" into peer bullets on commit.
                        if (label.includes(outlineBody_1.PEER_SPLIT_MARKER)) {
                            var split = (0, outlineBody_1.splitBulletLabelIntoPeers)(vm.doc, focusId);
                            if (split.count >= 2) {
                                vm.doc = split.doc;
                                vm.focusId = split.focusId;
                            }
                        }
                        vm.editMode = false;
                        var ok = vm.commit();
                        if (ok && prevLabel !== label) {
                            vm._stuffLinkedCaptionsAfterLabelEdit(prevLabel, label);
                        }
                        $timeout(function () {
                            focusMapEl();
                            if (vm.focusId)
                                scrollMapNodeIntoView(vm.focusId);
                        });
                        return ok;
                    },
                    /** Discard in-progress label edit without writing (Esc only). */
                    cancelEdit: function () {
                        vm.editMode = false;
                        $timeout(function () { return focusMapEl(); });
                    },
                    onEditKey: function (ev) {
                        var _a;
                        ev.stopPropagation();
                        if (ev.key === 'Escape') {
                            ev.preventDefault();
                            vm.cancelEdit();
                            return;
                        }
                        // Enter commits; Shift+Enter inserts a newline in the multi-line label.
                        if (ev.key === 'Enter' && !ev.shiftKey) {
                            ev.preventDefault();
                            vm.commitEdit();
                            return;
                        }
                        // Arrow up/down only leave edit at the start/end of the textarea.
                        if (ev.key === 'ArrowUp' || ev.key === 'ArrowDown') {
                            var ta = ev.target;
                            var pos = (_a = ta.selectionStart) !== null && _a !== void 0 ? _a : 0;
                            var val = ta.value || '';
                            var atStart = pos === 0;
                            var atEnd = pos === val.length;
                            if ((ev.key === 'ArrowUp' && atStart) ||
                                (ev.key === 'ArrowDown' && atEnd)) {
                                ev.preventDefault();
                                vm.commitEdit();
                                $timeout(function () {
                                    vm.onKey({
                                        key: ev.key,
                                        preventDefault: function () { },
                                        stopPropagation: function () { },
                                        ctrlKey: false,
                                        metaKey: false,
                                        shiftKey: false,
                                        target: elem[0].querySelector('.aud-outline__map'),
                                    }, vm.focusId || undefined);
                                });
                            }
                        }
                    },
                    onKey: function (ev, fromId) {
                        if (!vm.mapOn)
                            return;
                        if (vm.editMode) {
                            if (ev.key === 'Escape') {
                                // Android/Chrome: Esc can mean Back — always keep work first.
                                ev.preventDefault();
                                ev.stopPropagation();
                                // Prefer commit label into body rather than discard on Esc.
                                if (!vm.commitEdit()) {
                                    vm.cancelEdit();
                                }
                                emergencyPersistWork('escape-edit');
                            }
                            return;
                        }
                        if (ev.key === 'Escape') {
                            // Always prevent browser Back/history when map owns Esc, then persist.
                            ev.preventDefault();
                            ev.stopPropagation();
                            if (vm.presentMode) {
                                vm.setPresent(false);
                            }
                            emergencyPersistWork('escape-map');
                            return;
                        }
                        // Textarea is source of truth while focused there — ignore map keys.
                        var t = ev.target;
                        if (t && t.tagName === 'TEXTAREA' && t.classList.contains('aud-outline__textarea')) {
                            return;
                        }
                        if (!vm.doc || isBodyDivergedFromMap()) {
                            var structureKey = ev.key === '.' ||
                                ev.key === ' ' ||
                                ev.key === 'Enter' ||
                                ev.key === 'Tab' ||
                                ev.key === 'x' ||
                                ev.key === 'X' ||
                                ev.key === 'c' ||
                                ev.key === 'C' ||
                                ev.key === 's' ||
                                ev.key === 'S' ||
                                (ev.key.length === 1 && ev.key >= '0' && ev.key <= '9') ||
                                ev.key === 'Backspace' ||
                                ev.key === 'Delete' ||
                                (ev.altKey &&
                                    (ev.key === 'ArrowUp' ||
                                        ev.key === 'ArrowDown' ||
                                        ev.key === 'ArrowLeft' ||
                                        ev.key === 'ArrowRight'));
                            if (isBodyDivergedFromMap() && structureKey) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                guardMapWrite('pnBody changed — map reloaded; that key did not rewrite body.');
                                return;
                            }
                            if (!vm.doc || isBodyDivergedFromMap()) {
                                pullLiveBodyIntoModel();
                                vm.reparseFromBody();
                            }
                        }
                        if (!vm.doc || !(0, outlineBody_1.hasOutlineStructure)(getLiveBodyText())) {
                            if (ev.key === 'Enter') {
                                vm.addItem(ev);
                            }
                            return;
                        }
                        var focusId = fromId || vm.focusId;
                        var vis = vm.visible;
                        var idx = focusId ? vis.findIndex(function (n) { return n.bullet.id === focusId; }) : -1;
                        var cur = idx >= 0 ? vis[idx] : null;
                        var move = function (delta) {
                            if (!vis.length)
                                return;
                            var base = idx < 0 ? 0 : idx;
                            var next = Math.max(0, Math.min(vis.length - 1, base + delta));
                            vm.focusId = vis[next].bullet.id;
                            $timeout(function () {
                                focusMapEl();
                                scrollMapNodeIntoView(vm.focusId);
                            }, 0);
                        };
                        var afterFocusChange = function () {
                            $timeout(function () {
                                focusMapEl();
                                if (vm.focusId)
                                    scrollMapNodeIntoView(vm.focusId);
                            }, 0);
                        };
                        /** Keep highlight on the node that was reordered / indented. */
                        var keepFocusOn = function (id) {
                            vm.focusId = id;
                            afterFocusChange();
                        };
                        switch (ev.key) {
                            case 'ArrowUp':
                                if (ev.altKey) {
                                    // Alt+↑ — reorder: move node + descendants above previous sibling
                                    if (cur)
                                        vm.focusId = cur.bullet.id;
                                    vm.moveUp(ev);
                                }
                                else {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                    move(-1);
                                }
                                break;
                            case 'ArrowDown':
                                if (ev.altKey) {
                                    // Alt+↓ — reorder: move node + descendants below next sibling
                                    if (cur)
                                        vm.focusId = cur.bullet.id;
                                    vm.moveDown(ev);
                                }
                                else {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                    move(1);
                                }
                                break;
                            case 'ArrowLeft':
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (!cur)
                                    break;
                                if (ev.altKey) {
                                    // Alt+← — same as Shift+Tab (outdent)
                                    vm.focusId = cur.bullet.id;
                                    vm.outdent(ev);
                                    break;
                                }
                                if (!cur.bullet.collapsed && cur.children.length) {
                                    if (!guardMapWrite())
                                        break;
                                    vm.doc = (0, outlineBody_1.setCollapsed)(vm.doc, cur.bullet.id, true);
                                    vm.commit();
                                    keepFocusOn(cur.bullet.id);
                                }
                                else {
                                    for (var i = idx - 1; i >= 0; i--) {
                                        if (vis[i].bullet.depth < cur.bullet.depth) {
                                            vm.focusId = vis[i].bullet.id;
                                            break;
                                        }
                                    }
                                    afterFocusChange();
                                }
                                break;
                            case 'ArrowRight':
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (!cur)
                                    break;
                                if (ev.altKey) {
                                    // Alt+→ — same as Tab (indent)
                                    vm.focusId = cur.bullet.id;
                                    vm.indent(ev);
                                    break;
                                }
                                if (cur.children.length) {
                                    if (!guardMapWrite())
                                        break;
                                    vm.doc = (0, outlineBody_1.setCollapsed)(vm.doc, cur.bullet.id, false);
                                    vm.commit();
                                    // Prefer first revealed child; fall back to the expanded node.
                                    vm.focusId = cur.bullet.id;
                                    focusFirstRevealedChild(cur.bullet.id);
                                }
                                afterFocusChange();
                                break;
                            case '.':
                            case ' ':
                                if (!cur)
                                    break;
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (!guardMapWrite())
                                    break;
                                {
                                    var wasCollapsed = cur.bullet.collapsed;
                                    vm.doc = (0, outlineBody_1.toggleCollapse)(vm.doc, cur.bullet.id);
                                    vm.commit();
                                    vm.focusId = cur.bullet.id;
                                    if (wasCollapsed) {
                                        focusFirstRevealedChild(cur.bullet.id);
                                    }
                                }
                                afterFocusChange();
                                break;
                            case 'e':
                            case 'E':
                            case 'F2':
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (cur)
                                    vm.enterEdit(cur.bullet.id);
                                break;
                            case 'c':
                                // Collapse all
                                vm.collapseAll(ev);
                                break;
                            case 'C':
                                // Expand all
                                vm.expandAll(ev);
                                break;
                            case '0':
                            case '1':
                            case '2':
                            case '3':
                            case '4':
                            case '5':
                            case '6':
                            case '7':
                            case '8':
                            case '9':
                                ev.preventDefault();
                                ev.stopPropagation();
                                vm.expandToLevel(Number(ev.key), ev);
                                break;
                            case '?':
                            case 'i':
                            case 'I':
                                ev.preventDefault();
                                ev.stopPropagation();
                                vm.toggleHelp(ev);
                                break;
                            case 's':
                            case 'S':
                                if (cur)
                                    vm.focusId = cur.bullet.id;
                                vm.splitFocusedIntoPeers(ev);
                                break;
                            case 'Enter':
                                if (ev.ctrlKey || ev.metaKey) {
                                    if (cur)
                                        vm.focusId = cur.bullet.id;
                                    vm.addChild(ev);
                                }
                                else {
                                    if (cur)
                                        vm.focusId = cur.bullet.id;
                                    vm.addItem(ev);
                                }
                                break;
                            case 'Tab':
                                if (!cur) {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                    break;
                                }
                                vm.focusId = cur.bullet.id;
                                if (ev.shiftKey)
                                    vm.outdent(ev);
                                else
                                    vm.indent(ev);
                                break;
                            case 'Backspace':
                            case 'Delete':
                                if (!cur || cur.bullet.label.trim() !== '')
                                    break;
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (!guardMapWrite())
                                    break;
                                {
                                    var r = (0, outlineBody_1.deleteBulletIfEmpty)(vm.doc, cur.bullet.id);
                                    vm.doc = r.doc;
                                    vm.commit();
                                    vm.focusId = r.focusId;
                                }
                                afterFocusChange();
                                break;
                            case 'x':
                            case 'X':
                                if (!cur)
                                    break;
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (!guardMapWrite())
                                    break;
                                vm.doc = (0, outlineBody_1.toggleCheckbox)(vm.doc, cur.bullet.id);
                                vm.commit();
                                keepFocusOn(cur.bullet.id);
                                break;
                            default:
                                break;
                        }
                    },
                });
                function getBodyTextarea() {
                    return elem[0].querySelector('textarea.aud-outline__textarea');
                }
                function getBodyNgModel() {
                    var ta = getBodyTextarea();
                    if (!ta)
                        return null;
                    return angular_1.default.element(ta).controller('ngModel');
                }
                /** Body for flush/map: OPEN → TYPE → ACT rules (editBodyAuthority). */
                function getLiveBodyText() {
                    var ta = getBodyTextarea();
                    var model = scope.body == null ? '' : String(scope.body);
                    // Draft restore: never let stale textarea win until user types again.
                    if (preferModelUntilInput) {
                        return model;
                    }
                    return (0, editBodyAuthority_1.resolveAuthoritativeBody)({
                        model: model,
                        dom: ta ? ta.value : undefined,
                        hasTextarea: !!ta,
                        textareaFocused: !!(ta && document.activeElement === ta),
                    });
                }
                /**
                 * OPEN: paint empty textarea from model.
                 * TYPE→ACT: pull typed DOM into model before save/map/crypto.
                 */
                function pullLiveBodyIntoModel() {
                    var ta = getBodyTextarea();
                    var model = scope.body == null ? '' : String(scope.body);
                    if (preferModelUntilInput) {
                        if (ta && ta.value !== model) {
                            renderBodyToTextarea(model);
                        }
                        return;
                    }
                    var dom = ta ? ta.value : model;
                    var focused = !!(ta && document.activeElement === ta);
                    var heal = (0, editBodyAuthority_1.planDesyncHeal)(model, dom, focused);
                    if (heal.nextModel !== model) {
                        skipWatchForBody = null;
                        scope.body = heal.nextModel;
                        pushLiveBodyToParentDraft(heal.nextModel);
                    }
                    if (heal.writeDomFromModel) {
                        renderBodyToTextarea(heal.nextModel);
                    }
                }
                /** Apply restored/external body into isolate scope + textarea + map (must not be stomped by DOM). */
                function applyExternalBody(text) {
                    var next = text == null ? '' : String(text);
                    vm.editMode = false;
                    preferModelUntilInput = true;
                    skipWatchForBody = next;
                    scope.body = next;
                    syncedBodySnapshot = next;
                    renderBodyToTextarea(next);
                    // Force parent row.edit for this rowId only
                    pushLiveBodyToParentDraft(next, 'flush');
                    if (vm.mapOn) {
                        vm.reparseFromBody();
                    }
                    vm.staleWarning = null;
                }
                function isBodyDivergedFromMap() {
                    if (syncedBodySnapshot === null)
                        return false;
                    return getLiveBodyText() !== syncedBodySnapshot;
                }
                /**
                 * Before map mutates body: if live pnBody ≠ map snapshot, reload map and refuse write.
                 * @returns true if map is in sync and write may proceed
                 */
                function guardMapWrite(message) {
                    pullLiveBodyIntoModel();
                    if (!isBodyDivergedFromMap()) {
                        return true;
                    }
                    vm.editMode = false;
                    vm.staleWarning =
                        message ||
                            'pnBody text changed while the map was open. Map reloaded from text; map edit was not applied over your body.';
                    vm.reparseFromBody();
                    return false;
                }
                function captureFocusById(id) {
                    if (!vm.doc)
                        return null;
                    var bullets = vm.doc.lines.filter(function (l) { return l.kind === 'bullet'; });
                    var bi = bullets.findIndex(function (b) { return b.id === id; });
                    if (bi < 0)
                        return null;
                    var b = bullets[bi];
                    var nth = 0;
                    for (var i = 0; i < bi; i++) {
                        if (bullets[i].depth === b.depth && bullets[i].label === b.label)
                            nth++;
                    }
                    return {
                        depth: b.depth,
                        label: b.label,
                        nth: nth,
                        visibleIndex: Math.max(0, vm.visible.findIndex(function (n) { return n.bullet.id === id; })),
                    };
                }
                function findBulletIdByFingerprint(fp) {
                    if (!vm.doc)
                        return null;
                    var bullets = vm.doc.lines.filter(function (l) { return l.kind === 'bullet'; });
                    var nth = 0;
                    for (var _i = 0, bullets_2 = bullets; _i < bullets_2.length; _i++) {
                        var b = bullets_2[_i];
                        if (b.depth === fp.depth && b.label === fp.label) {
                            if (nth === fp.nth)
                                return b.id;
                            nth++;
                        }
                    }
                    return null;
                }
                /** Always attach this outline's rowId so multi-row editors never cross-apply. */
                function eventRowId() {
                    return scope.rowId != null && scope.rowId !== '' ? scope.rowId : undefined;
                }
                /**
                 * Write model + ngModel view together. Never assign textarea.value alone
                 * (that desyncs Angular and breaks draft restore / archive recover).
                 */
                function scheduleDebouncedDraftPersist() {
                    try {
                        scope.$root.$broadcast('audDraftSchedulePersist', { rowId: eventRowId() });
                    }
                    catch (_a) {
                        /* ignore */
                    }
                }
                /**
                 * Continuous typing capture — fires on every `input` (not blur-only).
                 * Writes silent typing-stream diffs + working stream; optional draft debounce.
                 */
                function captureTypingFromTextarea(source) {
                    if (source === void 0) { source = 'type'; }
                    // User is typing again — live DOM is authority.
                    preferModelUntilInput = false;
                    var ta = getBodyTextarea();
                    var live = ta ? ta.value : scope.body == null ? '' : String(scope.body);
                    skipWatchForBody = null;
                    if (scope.body !== live) {
                        scope.body = live;
                    }
                    // applyLiveBody → working stream + typing-stream ticks (silent; not draft pill)
                    pushLiveBodyToParentDraft(live, 'type');
                    try {
                        scope.$root.$broadcast('audTypingStream', {
                            body: live,
                            source: source,
                            rowId: eventRowId(),
                        });
                    }
                    catch (_a) {
                        /* ignore */
                    }
                    scheduleDebouncedDraftPersist();
                }
                function bindTypingCapture() {
                    var ta = getBodyTextarea();
                    if (!ta || ta._audTypingBound)
                        return;
                    ta._audTypingBound = true;
                    ta.addEventListener('input', function () {
                        var _a;
                        try {
                            if (((_a = scope.$root) === null || _a === void 0 ? void 0 : _a.$$phase) || scope.$$phase) {
                                captureTypingFromTextarea('type');
                            }
                            else {
                                scope.$applyAsync(function () { return captureTypingFromTextarea('type'); });
                            }
                        }
                        catch (_b) {
                            // Last resort outside Angular — still push streams (must include rowId)
                            try {
                                var live = ta.value;
                                var rowId = eventRowId();
                                scope.$root.$broadcast('audDraftApplyLiveBody', {
                                    body: live,
                                    source: 'type',
                                    rowId: rowId,
                                });
                                scope.$root.$broadcast('audTypingStream', {
                                    body: live,
                                    source: 'type',
                                    rowId: rowId,
                                });
                            }
                            catch (_c) {
                                /* ignore */
                            }
                        }
                    });
                    ta.addEventListener('paste', function () {
                        // Paste fires input after; mark next as paste via microtask
                        setTimeout(function () {
                            try {
                                scope.$applyAsync(function () { return captureTypingFromTextarea('paste'); });
                            }
                            catch (_a) {
                                /* ignore */
                            }
                        }, 0);
                    });
                }
                /**
                 * Push body onto parent row.edit sessions before any draft flush.
                 * Critical: isolate `body=` lag used to persist *stale* map-less text.
                 * Always scoped by this outline's rowId — never fan out to other open edits.
                 */
                function pushLiveBodyToParentDraft(body, source) {
                    if (source === void 0) { source = 'unknown'; }
                    var text = body != null
                        ? String(body)
                        : scope.body == null
                            ? ''
                            : String(scope.body);
                    var rowId = eventRowId();
                    // Without a rowId we must not broadcast live body (multi-edit safety).
                    if (rowId === undefined) {
                        return;
                    }
                    try {
                        scope.$root.$broadcast('audDraftApplyLiveBody', {
                            body: text,
                            source: source,
                            rowId: rowId,
                        });
                    }
                    catch (_a) {
                        /* ignore */
                    }
                }
                function persistDraftImmediate() {
                    var rowId = eventRowId();
                    if (rowId === undefined) {
                        return;
                    }
                    try {
                        scope.$root.$broadcast('audDraftPersistHint', { rowId: rowId });
                    }
                    catch (_a) {
                        /* ignore */
                    }
                }
                /**
                 * Best-effort save of map + textarea before Back / tab kill / Esc / hide / $destroy.
                 * Synchronous localStorage via draft service — do not rely on digests after this.
                 * Always scoped to this outline's rowId so destroy of A cannot stomp open edit B.
                 */
                function emergencyPersistWork(_reason) {
                    try {
                        var rowId = eventRowId();
                        // 1) Finish in-map label edit into the tree when safe
                        if (vm.editMode && vm.doc && vm.focusId) {
                            if (!isBodyDivergedFromMap()) {
                                try {
                                    vm.commitEdit();
                                }
                                catch (_a) {
                                    try {
                                        vm.cancelEdit();
                                    }
                                    catch (_b) {
                                        /* ignore */
                                    }
                                }
                            }
                            else {
                                try {
                                    vm.cancelEdit();
                                }
                                catch (_c) {
                                    /* ignore */
                                }
                            }
                        }
                        // 2) Prefer serialized map when it still matches body (structure edits live in doc)
                        var text = void 0;
                        if (vm.mapOn && vm.doc && !isBodyDivergedFromMap()) {
                            text = (0, outlineBody_1.serializeOutlineBody)(vm.doc);
                            skipWatchForBody = text;
                            scope.body = text;
                            syncedBodySnapshot = text;
                            try {
                                renderBodyToTextarea(text);
                            }
                            catch (_d) {
                                /* ignore */
                            }
                        }
                        else {
                            pullLiveBodyIntoModel();
                            text = scope.body == null ? '' : String(scope.body);
                        }
                        // 3) Force parent + typing/working streams for THIS row only, then sync localStorage
                        if (rowId === undefined) {
                            return;
                        }
                        pushLiveBodyToParentDraft(text, 'emergency');
                        try {
                            scope.$root.$broadcast('audTypingStream', {
                                body: text,
                                source: 'emergency',
                                immediate: true,
                                rowId: rowId,
                            });
                            scope.$root.$broadcast('audTypingStreamFlush', { rowId: rowId });
                        }
                        catch (_f) {
                            /* ignore */
                        }
                        persistDraftImmediate();
                    }
                    catch (_g) {
                        /* never throw from unload path */
                    }
                }
                function writeBody(text) {
                    var next = text == null ? '' : String(text);
                    skipWatchForBody = next;
                    writingFromMap = true;
                    scope.body = next;
                    syncedBodySnapshot = next;
                    renderBodyToTextarea(next);
                    // Apply to parent + working stream first, then immediate draft (map reorder/indent).
                    pushLiveBodyToParentDraft(next, 'map');
                    persistDraftImmediate();
                    // Clear after this digest + any nested ng-change / $timeout(0) from map keys.
                    $timeout(function () {
                        writingFromMap = false;
                    }, 0);
                }
                /**
                 * After expand, put highlight on the first newly visible child (if any).
                 * Caller leaves focus on parent when there are no children or fold was a collapse.
                 */
                function focusFirstRevealedChild(parentId) {
                    if (!vm.doc)
                        return;
                    var v2 = (0, outlineBody_1.flattenVisible)((0, outlineBody_1.buildOutlineForest)(vm.doc));
                    var at = v2.findIndex(function (n) { return n.bullet.id === parentId; });
                    if (at < 0)
                        return;
                    var parent = v2[at];
                    var next = v2[at + 1];
                    if (next && next.bullet.depth > parent.bullet.depth) {
                        vm.focusId = next.bullet.id;
                    }
                }
                function renderBodyToTextarea(text) {
                    var ta = getBodyTextarea();
                    var ngModel = getBodyNgModel();
                    var next = text == null ? '' : String(text);
                    if (ngModel) {
                        if (ngModel.$viewValue !== next) {
                            ngModel.$setViewValue(next);
                        }
                        ngModel.$render();
                    }
                    else if (ta && ta.value !== next) {
                        ta.value = next;
                    }
                }
                function focusMapEl() {
                    var map = elem[0].querySelector('.aud-outline__map');
                    map === null || map === void 0 ? void 0 : map.focus({ preventScroll: true });
                }
                /**
                 * ACT step: after OPEN → TYPE, flush body before Save / Map / crypto.
                 * Uses open→type→act rules; external restore uses audOutlineBodyExternal.
                 */
                function flushPendingBody() {
                    if (vm.editMode && vm.doc && vm.focusId) {
                        if (isBodyDivergedFromMap()) {
                            vm.editMode = false;
                            guardMapWrite('pnBody changed during map label edit — label discarded; map reloaded from text.');
                            return;
                        }
                        vm.commitEdit();
                        return;
                    }
                    vm.editMode = false;
                    pullLiveBodyIntoModel();
                }
                scope.$on('audOutlineFlush', function (_e, payload) {
                    // Scoped flush: only this outline when rowId is provided (multi-edit safe).
                    if (payload &&
                        payload.rowId != null &&
                        payload.rowId !== '' &&
                        scope.rowId != null &&
                        String(payload.rowId) !== String(scope.rowId)) {
                        return;
                    }
                    flushPendingBody();
                    pushLiveBodyToParentDraft(undefined, 'flush');
                    if (vm.mapOn) {
                        vm.reparseFromBody();
                    }
                });
                /** Emergency: Back / tab hide / app switch — keep brainstorm text (this row). */
                scope.$on('audDraftEmergencyPersist', function (_e, payload) {
                    if (payload &&
                        payload.rowId != null &&
                        payload.rowId !== '' &&
                        scope.rowId != null &&
                        String(payload.rowId) !== String(scope.rowId)) {
                        return;
                    }
                    emergencyPersistWork('emergency-event');
                });
                /**
                 * Draft restore / archive / crypto applied on parent — force textarea + map.
                 * Payload should include { body, rowId }. Without matching rowId, ignore
                 * (never apply another note's body to this outline).
                 */
                scope.$on('audOutlineBodyExternal', function (_e, payload) {
                    if (payload &&
                        payload.rowId != null &&
                        payload.rowId !== '' &&
                        scope.rowId != null &&
                        String(payload.rowId) !== String(scope.rowId)) {
                        return;
                    }
                    // Require rowId when this outline knows its id — refuse unscoped external applies
                    // while multi-row editors may be open.
                    if (scope.rowId != null &&
                        scope.rowId !== '' &&
                        (!payload || payload.rowId == null || payload.rowId === '')) {
                        return;
                    }
                    var text = payload && payload.body != null
                        ? String(payload.body)
                        : scope.body == null
                            ? ''
                            : String(scope.body);
                    applyExternalBody(text);
                    // Second paint after digest — ngModel sometimes lags one tick
                    $timeout(function () {
                        if (preferModelUntilInput) {
                            var m = scope.body == null ? '' : String(scope.body);
                            renderBodyToTextarea(m);
                            syncedBodySnapshot = m;
                            if (vm.mapOn) {
                                vm.reparseFromBody();
                            }
                        }
                    }, 0);
                });
                /** Zen page: open map in presentation layout for the single loaded note. */
                scope.$on('audOutlineZenEnter', function () {
                    enterPresentFromQueryOrZen(true);
                });
                /** Shared enter for ?present=1 and /zen/… */
                function enterPresentFromQueryOrZen(forceDarkHint) {
                    pullLiveBodyIntoModel();
                    if (!vm.mapOn) {
                        vm.mapOn = true;
                    }
                    vm.reparseFromBody();
                    vm.setPresent(true);
                    if (forceDarkHint &&
                        !vm.mapDark &&
                        document.documentElement.classList.contains('night-mode')) {
                        vm.mapDark = true;
                    }
                    $timeout(function () {
                        focusMapEl();
                        if (vm.focusId)
                            scrollMapNodeIntoView(vm.focusId);
                        else if (vm.visible[0]) {
                            vm.focusId = vm.visible[0].bullet.id;
                            scrollMapNodeIntoView(vm.focusId);
                        }
                    }, 0);
                }
                function urlWantsPresent() {
                    try {
                        var q = new URLSearchParams($window.location.search || '');
                        var p = (q.get('present') || '').toLowerCase();
                        return p === '1' || p === 'true' || p === 'yes';
                    }
                    catch (_a) {
                        return false;
                    }
                }
                /**
                 * Highlight map node for the current caret line in the body textarea.
                 * Optionally expand collapsed ancestors so the line's bullet is visible.
                 */
                function focusMapFromCaret(expandAncestors) {
                    var _a;
                    if (!vm.mapOn || !vm.doc)
                        return;
                    var ta = getBodyTextarea();
                    if (!ta)
                        return;
                    var pos = (_a = ta.selectionStart) !== null && _a !== void 0 ? _a : 0;
                    var lineIndex = ta.value.slice(0, pos).split('\n').length - 1;
                    var id = (0, outlineBody_1.bulletIdAtSourceLine)(vm.doc, lineIndex);
                    if (!id)
                        return;
                    if (expandAncestors) {
                        var expanded = (0, outlineBody_1.expandAncestorsOf)(vm.doc, id);
                        if (expanded !== vm.doc) {
                            // In-memory only so caret can see the leaf — does not rewrite pnBody.
                            // Map fold keys still persist via commit(); text edit reparse restores markers.
                            vm.doc = expanded;
                            vm.forest = (0, outlineBody_1.buildOutlineForest)(vm.doc);
                            vm.visible = (0, outlineBody_1.flattenVisible)(vm.forest);
                        }
                    }
                    id = (0, outlineBody_1.bulletIdAtSourceLine)(vm.doc, lineIndex) || id;
                    if (vm.focusId !== id) {
                        vm.focusId = id;
                    }
                    $timeout(function () { return scrollMapNodeIntoView(id); }, 0);
                }
                /**
                 * Keep focused map node inside the scrollport.
                 * Uses getBoundingClientRect (not offsetTop) so zoom transform + nested layout stay correct.
                 */
                function scrollMapNodeIntoView(id) {
                    var map = elem[0].querySelector('.aud-outline__map');
                    if (!map || !id)
                        return;
                    var nodeEl = map.querySelector(".aud-outline__node[data-outline-id=\"".concat(cssEscape(id), "\"]"));
                    if (!nodeEl)
                        return;
                    var pad = 16; // keep clear of top/bottom edge (toolbar/chrome feel)
                    var mapRect = map.getBoundingClientRect();
                    var nodeRect = nodeEl.getBoundingClientRect();
                    if (nodeRect.top < mapRect.top + pad) {
                        map.scrollTop -= mapRect.top + pad - nodeRect.top;
                    }
                    else if (nodeRect.bottom > mapRect.bottom - pad) {
                        map.scrollTop += nodeRect.bottom - (mapRect.bottom - pad);
                    }
                    // Clamp — avoid scrolling past content into empty “under” area
                    var maxScroll = Math.max(0, map.scrollHeight - map.clientHeight);
                    if (map.scrollTop < 0)
                        map.scrollTop = 0;
                    if (map.scrollTop > maxScroll)
                        map.scrollTop = maxScroll;
                }
                function cssEscape(value) {
                    var _a;
                    if (typeof ((_a = window.CSS) === null || _a === void 0 ? void 0 : _a.escape) === 'function') {
                        return window.CSS.escape(value);
                    }
                    return value.replace(/"/g, '\\"');
                }
                // When body changes (typing, draft restore, map commit): update map view only.
                // Desync heal: empty unfocused DOM gets model (open); non-empty DOM updates model.
                // After external restore, preferModelUntilInput forces model → DOM (never stomp recover).
                scope.$watch('body', function (newVal, oldVal) {
                    var text = newVal == null ? '' : String(newVal);
                    if (skipWatchForBody !== null && text === skipWatchForBody) {
                        skipWatchForBody = null;
                        // Map wrote body — keep ngModel view matched.
                        renderBodyToTextarea(text);
                        syncedBodySnapshot = text;
                        return;
                    }
                    var ta = getBodyTextarea();
                    if (preferModelUntilInput) {
                        if (ta && ta.value !== text) {
                            renderBodyToTextarea(text);
                        }
                        syncedBodySnapshot = text;
                        if (vm.mapOn && newVal !== oldVal) {
                            if (vm.editMode)
                                vm.editMode = false;
                            vm.reparseFromBody();
                        }
                        return;
                    }
                    if (ta && ta.value !== text) {
                        var focused = document.activeElement === ta;
                        var heal = (0, editBodyAuthority_1.planDesyncHeal)(text, ta.value, focused);
                        if (heal.nextModel !== text) {
                            // DOM ahead (user typed) — model will update; avoid reparse thrash this tick
                            skipWatchForBody = null;
                            scope.body = heal.nextModel;
                            return;
                        }
                        if (heal.writeDomFromModel) {
                            // Hydration: model has content, textarea still empty
                            renderBodyToTextarea(text);
                        }
                    }
                    if (!vm.mapOn)
                        return;
                    if (newVal === oldVal && vm.doc && vm.visible.length) {
                        return;
                    }
                    // User typed in pnBody: drop map label edit and reparse (never serialize over).
                    if (vm.editMode) {
                        vm.editMode = false;
                    }
                    vm.reparseFromBody();
                    if (ta && document.activeElement === ta) {
                        focusMapFromCaret(true);
                    }
                });
                // Keep vm.rows in sync with two-way `rows` (parent more/less rows links).
                scope.$watch('rows', function (r) {
                    var n = Number(r);
                    if (n && n !== vm.rows) {
                        vm.rows = n;
                    }
                });
                // Ctrl/Cmd + wheel zoom on map (passive:false required for preventDefault)
                elem.on('wheel', function (e) {
                    var _a, _b;
                    var oe = e.originalEvent || e;
                    if (!vm.mapOn)
                        return;
                    if (!oe.ctrlKey && !oe.metaKey)
                        return;
                    var mapEl = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, '.aud-outline__map');
                    if (!mapEl)
                        return;
                    oe.preventDefault();
                    scope.$apply(function () {
                        if (oe.deltaY < 0)
                            vm.zoomIn();
                        else
                            vm.zoomOut();
                    });
                });
                // --- Navigation / unload durability (Android Back, tab kill, app background) ---
                var onPageHide = function () { return emergencyPersistWork('pagehide'); };
                var onBeforeUnload = function () { return emergencyPersistWork('beforeunload'); };
                var onVisibility = function () {
                    if (document.visibilityState === 'hidden') {
                        emergencyPersistWork('visibilityhidden');
                    }
                };
                var onPopState = function () { return emergencyPersistWork('popstate'); };
                var onFreeze = function () { return emergencyPersistWork('freeze'); };
                var onDocKeydown = function (ev) {
                    if (ev.key !== 'Escape' && ev.keyCode !== 27)
                        return;
                    // Only when this outline is open (edit form alive)
                    if (!vm.show)
                        return;
                    // Capture phase: beat browser Back-as-Esc where possible
                    try {
                        emergencyPersistWork('document-escape');
                    }
                    catch (_a) {
                        /* ignore */
                    }
                };
                // Capture phase so we apply live map/text *before* draft service window flush.
                window.addEventListener('pagehide', onPageHide, true);
                window.addEventListener('beforeunload', onBeforeUnload, true);
                window.addEventListener('popstate', onPopState, true);
                document.addEventListener('visibilitychange', onVisibility, true);
                document.addEventListener('keydown', onDocKeydown, true);
                try {
                    document.addEventListener('freeze', onFreeze, true);
                }
                catch (_a) {
                    /* ignore */
                }
                scope.$on('$destroy', function () {
                    try {
                        emergencyPersistWork('destroy');
                    }
                    catch (_a) {
                        /* ignore */
                    }
                    try {
                        (0, outlineMapPrefs_1.flushDisplayStyleServerSync)(resolvePersonId(), scope.rowId, getPatchFields());
                    }
                    catch (_b) {
                        /* ignore */
                    }
                    window.removeEventListener('pagehide', onPageHide, true);
                    window.removeEventListener('beforeunload', onBeforeUnload, true);
                    window.removeEventListener('popstate', onPopState, true);
                    document.removeEventListener('visibilitychange', onVisibility, true);
                    document.removeEventListener('keydown', onDocKeydown, true);
                    try {
                        document.removeEventListener('freeze', onFreeze, true);
                    }
                    catch (_c) {
                        /* ignore */
                    }
                });
                // OPEN: model is authority for this row — paint textarea immediately so a prior
                // editor's DOM/value cannot linger when switching notes.
                {
                    var openText_1 = scope.body == null ? '' : String(scope.body);
                    preferModelUntilInput = true;
                    skipWatchForBody = openText_1;
                    syncedBodySnapshot = openText_1;
                    $timeout(function () {
                        renderBodyToTextarea(openText_1);
                        if (preferModelUntilInput) {
                            renderBodyToTextarea(scope.body == null ? '' : String(scope.body));
                        }
                    }, 0);
                }
                // Map open: per-row style wins; else auto-open when body has outline structure.
                {
                    var hasStruct = (0, outlineBody_1.hasOutlineStructure)(scope.body || '');
                    if ((rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.mapOn) === false) {
                        vm.mapOn = false;
                    }
                    else if ((rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.mapOn) === true || ((rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.mapOn) == null && hasStruct)) {
                        if (hasStruct || (rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.mapOn) === true) {
                            vm.mapOn = true;
                            if (hasStruct)
                                vm.reparseFromBody();
                        }
                    }
                }
                // Continuous keystroke capture (native input — not blur / change-only).
                $timeout(function () { return bindTypingCapture(); }, 0);
                // Re-bind if textarea is recreated (map layout toggles keep same node; safe no-op).
                scope.$watch(function () { return !!getBodyTextarea(); }, function (has) {
                    if (has)
                        bindTypingCapture();
                });
                // If parent rebinds body for the same directive instance, force model → DOM.
                // (row-id is fixed per result-row template; body still changes on open/restore.)
                scope.$watch('rowId', function (newId, oldId) {
                    if (newId === oldId)
                        return;
                    var text = scope.body == null ? '' : String(scope.body);
                    applyExternalBody(text);
                });
                // ?present=1 on any page with the outline (e.g. /view/pnid/123?present=1 after edit opens)
                if (urlWantsPresent()) {
                    $timeout(function () { return enterPresentFromQueryOrZen(false); }, 0);
                }
            },
        };
    },
]);
exports.default = exports.outlineBodyModule.name;
